// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  formDataBodySerializer,
  type Options as Options2,
  type TDataShape,
  urlSearchParamsBodySerializer
} from './client';
import { client } from './client.gen';
import {
  authenticateCredentialResponseTransformer,
  authenticateSingleSignOnResponseTransformer,
  cancelSubscriptionResponseTransformer,
  changeSubscriptionPlanPatchResponseTransformer,
  changeSubscriptionPlanPutResponseTransformer,
  confirmCredentialMfaAuthenticatorForCallerPatchResponseTransformer,
  confirmCredentialMfaAuthenticatorForCallerPutResponseTransformer,
  forceCancelSubscriptionResponseTransformer,
  formatsTestingOnlyResponseTransformer,
  getOAuth2ClientResponseTransformer,
  getSubscriptionResponseTransformer,
  makeBookingResponseTransformer,
  refreshTokenResponseTransformer,
  regenerateOAuth2ClientSecretResponseTransformer,
  registerMachineResponseTransformer,
  searchAllApiKeysForCallerResponseTransformer,
  searchAllAuditsResponseTransformer,
  searchAllBookingsResponseTransformer,
  searchAllEmailDeliveriesResponseTransformer,
  searchAllEventNotificationsResponseTransformer,
  searchAllSmsDeliveriesResponseTransformer,
  searchSubscriptionHistoryResponseTransformer,
  transferSubscriptionPatchResponseTransformer,
  transferSubscriptionPutResponseTransformer,
  verifyCredentialMfaAuthenticatorForCallerPatchResponseTransformer,
  verifyCredentialMfaAuthenticatorForCallerPutResponseTransformer
} from './transformers.gen';
import type {
  AssignPlatformRolesData,
  AssignPlatformRolesErrors,
  AssignPlatformRolesResponses,
  AssignRolesToOrganizationPatchData,
  AssignRolesToOrganizationPatchErrors,
  AssignRolesToOrganizationPatchResponses,
  AssignRolesToOrganizationPutData,
  AssignRolesToOrganizationPutErrors,
  AssignRolesToOrganizationPutResponses,
  AssociateCredentialMfaAuthenticatorForCallerData,
  AssociateCredentialMfaAuthenticatorForCallerErrors,
  AssociateCredentialMfaAuthenticatorForCallerResponses,
  AuthenticateCredentialData,
  AuthenticateCredentialErrors,
  AuthenticateCredentialResponses,
  AuthenticateSingleSignOnData,
  AuthenticateSingleSignOnErrors,
  AuthenticateSingleSignOnResponses,
  AuthorizeByAnonymousTestingOnlyData,
  AuthorizeByAnonymousTestingOnlyErrors,
  AuthorizeByAnonymousTestingOnlyResponses,
  AuthorizeByFeatureTestingOnlyData,
  AuthorizeByFeatureTestingOnlyErrors,
  AuthorizeByFeatureTestingOnlyResponses,
  AuthorizeByTokenWithRoleTestingOnlyData,
  AuthorizeByTokenWithRoleTestingOnlyErrors,
  AuthorizeByTokenWithRoleTestingOnlyResponses,
  AuthorizeOAuth2Data,
  AuthorizeOAuth2Errors,
  AuthorizeOAuth2Responses,
  CancelBookingData,
  CancelBookingErrors,
  CancelBookingResponses,
  CancelSubscriptionData,
  CancelSubscriptionErrors,
  CancelSubscriptionResponses,
  ChallengeCredentialMfaAuthenticatorForCallerPatchData,
  ChallengeCredentialMfaAuthenticatorForCallerPatchErrors,
  ChallengeCredentialMfaAuthenticatorForCallerPatchResponses,
  ChallengeCredentialMfaAuthenticatorForCallerPutData,
  ChallengeCredentialMfaAuthenticatorForCallerPutErrors,
  ChallengeCredentialMfaAuthenticatorForCallerPutResponses,
  ChangeCredentialMfaForCallerPatchData,
  ChangeCredentialMfaForCallerPatchErrors,
  ChangeCredentialMfaForCallerPatchResponses,
  ChangeCredentialMfaForCallerPutData,
  ChangeCredentialMfaForCallerPutErrors,
  ChangeCredentialMfaForCallerPutResponses,
  ChangeDefaultOrganizationPatchData,
  ChangeDefaultOrganizationPatchErrors,
  ChangeDefaultOrganizationPatchResponses,
  ChangeDefaultOrganizationPutData,
  ChangeDefaultOrganizationPutErrors,
  ChangeDefaultOrganizationPutResponses,
  ChangeOAuth2ClientLogoPatchData,
  ChangeOAuth2ClientLogoPatchErrors,
  ChangeOAuth2ClientLogoPatchResponses,
  ChangeOAuth2ClientLogoPutData,
  ChangeOAuth2ClientLogoPutErrors,
  ChangeOAuth2ClientLogoPutResponses,
  ChangeOrganizationAvatarPatchData,
  ChangeOrganizationAvatarPatchErrors,
  ChangeOrganizationAvatarPatchResponses,
  ChangeOrganizationAvatarPutData,
  ChangeOrganizationAvatarPutErrors,
  ChangeOrganizationAvatarPutResponses,
  ChangeOrganizationPatchData,
  ChangeOrganizationPatchErrors,
  ChangeOrganizationPatchResponses,
  ChangeOrganizationPutData,
  ChangeOrganizationPutErrors,
  ChangeOrganizationPutResponses,
  ChangeProfileAvatarPatchData,
  ChangeProfileAvatarPatchErrors,
  ChangeProfileAvatarPatchResponses,
  ChangeProfileAvatarPutData,
  ChangeProfileAvatarPutErrors,
  ChangeProfileAvatarPutResponses,
  ChangeProfileContactAddressPatchData,
  ChangeProfileContactAddressPatchErrors,
  ChangeProfileContactAddressPatchResponses,
  ChangeProfileContactAddressPutData,
  ChangeProfileContactAddressPutErrors,
  ChangeProfileContactAddressPutResponses,
  ChangeProfilePatchData,
  ChangeProfilePatchErrors,
  ChangeProfilePatchResponses,
  ChangeProfilePutData,
  ChangeProfilePutErrors,
  ChangeProfilePutResponses,
  ChangeSubscriptionPlanPatchData,
  ChangeSubscriptionPlanPatchErrors,
  ChangeSubscriptionPlanPatchResponses,
  ChangeSubscriptionPlanPutData,
  ChangeSubscriptionPlanPutErrors,
  ChangeSubscriptionPlanPutResponses,
  ChargebeeNotifyWebhookEventData,
  ChargebeeNotifyWebhookEventErrors,
  ChargebeeNotifyWebhookEventResponses,
  CompletePasswordResetData,
  CompletePasswordResetErrors,
  CompletePasswordResetResponses,
  ConfirmCredentialMfaAuthenticatorForCallerPatchData,
  ConfirmCredentialMfaAuthenticatorForCallerPatchErrors,
  ConfirmCredentialMfaAuthenticatorForCallerPatchResponses,
  ConfirmCredentialMfaAuthenticatorForCallerPutData,
  ConfirmCredentialMfaAuthenticatorForCallerPutErrors,
  ConfirmCredentialMfaAuthenticatorForCallerPutResponses,
  ConfirmEmailDeliveredData,
  ConfirmEmailDeliveredErrors,
  ConfirmEmailDeliveredResponses,
  ConfirmEmailDeliveryFailedData,
  ConfirmEmailDeliveryFailedErrors,
  ConfirmEmailDeliveryFailedResponses,
  ConfirmPersonCredentialRegistrationData,
  ConfirmPersonCredentialRegistrationErrors,
  ConfirmPersonCredentialRegistrationResponses,
  ConfirmSmsDeliveredData,
  ConfirmSmsDeliveredErrors,
  ConfirmSmsDeliveredResponses,
  ConfirmSmsDeliveryFailedData,
  ConfirmSmsDeliveryFailedErrors,
  ConfirmSmsDeliveryFailedResponses,
  ConsentOAuth2ClientForCallerData,
  ConsentOAuth2ClientForCallerErrors,
  ConsentOAuth2ClientForCallerResponses,
  ContentNegotiationsTestingOnlyData,
  ContentNegotiationsTestingOnlyErrors,
  ContentNegotiationsTestingOnlyResponses,
  CreateApiKeyData,
  CreateApiKeyErrors,
  CreateApiKeyResponses,
  CreateOAuth2ClientData,
  CreateOAuth2ClientErrors,
  CreateOAuth2ClientResponses,
  CreateOrganizationData,
  CreateOrganizationErrors,
  CreateOrganizationResponses,
  DeleteApiKeyData,
  DeleteApiKeyErrors,
  DeleteApiKeyResponses,
  DeleteCarData,
  DeleteCarErrors,
  DeleteCarResponses,
  DeleteImageData,
  DeleteImageErrors,
  DeleteImageResponses,
  DeleteOAuth2ClientData,
  DeleteOAuth2ClientErrors,
  DeleteOAuth2ClientLogoData,
  DeleteOAuth2ClientLogoErrors,
  DeleteOAuth2ClientLogoResponses,
  DeleteOAuth2ClientResponses,
  DeleteOrganizationAvatarData,
  DeleteOrganizationAvatarErrors,
  DeleteOrganizationAvatarResponses,
  DeleteOrganizationData,
  DeleteOrganizationErrors,
  DeleteOrganizationResponses,
  DeleteProfileAvatarData,
  DeleteProfileAvatarErrors,
  DeleteProfileAvatarResponses,
  DeliverAuditData,
  DeliverAuditErrors,
  DeliverAuditResponses,
  DeliverUsageData,
  DeliverUsageErrors,
  DeliverUsageResponses,
  DestroyAllRepositoriesData,
  DestroyAllRepositoriesErrors,
  DestroyAllRepositoriesResponses,
  DisassociateCredentialMfaAuthenticatorForCallerData,
  DisassociateCredentialMfaAuthenticatorForCallerErrors,
  DisassociateCredentialMfaAuthenticatorForCallerResponses,
  DownloadImageData,
  DownloadImageErrors,
  DownloadImageResponses,
  DownloadStreamTestingOnlyData,
  DownloadStreamTestingOnlyErrors,
  DownloadStreamTestingOnlyResponses,
  DrainAllAuditsData,
  DrainAllAuditsErrors,
  DrainAllAuditsResponses,
  DrainAllEmailsData,
  DrainAllEmailsErrors,
  DrainAllEmailsResponses,
  DrainAllEventNotificationsData,
  DrainAllEventNotificationsErrors,
  DrainAllEventNotificationsResponses,
  DrainAllProvisioningsData,
  DrainAllProvisioningsErrors,
  DrainAllProvisioningsResponses,
  DrainAllSmsesData,
  DrainAllSmsesErrors,
  DrainAllSmsesResponses,
  DrainAllUsagesData,
  DrainAllUsagesErrors,
  DrainAllUsagesResponses,
  ErrorsErrorTestingOnlyData,
  ErrorsErrorTestingOnlyErrors,
  ErrorsErrorTestingOnlyResponses,
  ErrorsThrowTestingOnlyData,
  ErrorsThrowTestingOnlyErrors,
  ErrorsThrowTestingOnlyResponses,
  ExchangeOAuth2ForTokensData,
  ExchangeOAuth2ForTokensErrors,
  ExchangeOAuth2ForTokensResponses,
  ExportSubscriptionsToMigrateData,
  ExportSubscriptionsToMigrateErrors,
  ExportSubscriptionsToMigrateResponses,
  ForceCancelSubscriptionData,
  ForceCancelSubscriptionErrors,
  ForceCancelSubscriptionResponses,
  FormatsTestingOnlyData,
  FormatsTestingOnlyErrors,
  FormatsTestingOnlyResponses,
  GetAllFeatureFlagsData,
  GetAllFeatureFlagsErrors,
  GetAllFeatureFlagsResponses,
  GetCallerWithHmacTestingOnlyData,
  GetCallerWithHmacTestingOnlyErrors,
  GetCallerWithHmacTestingOnlyResponses,
  GetCallerWithTokenOrApiKeyTestingOnlyData,
  GetCallerWithTokenOrApiKeyTestingOnlyErrors,
  GetCallerWithTokenOrApiKeyTestingOnlyResponses,
  GetCarData,
  GetCarErrors,
  GetCarResponses,
  GetDiscoveryDocumentData,
  GetDiscoveryDocumentErrors,
  GetDiscoveryDocumentResponses,
  GetFeatureFlagData,
  GetFeatureFlagErrors,
  GetFeatureFlagForCallerData,
  GetFeatureFlagForCallerErrors,
  GetFeatureFlagForCallerResponses,
  GetFeatureFlagResponses,
  GetIdentityForCallerData,
  GetIdentityForCallerErrors,
  GetIdentityForCallerResponses,
  GetImageData,
  GetImageErrors,
  GetImageResponses,
  GetInsecureTestingOnlyData,
  GetInsecureTestingOnlyErrors,
  GetInsecureTestingOnlyResponses,
  GetJsonWebKeySetData,
  GetJsonWebKeySetErrors,
  GetJsonWebKeySetResponses,
  GetOAuth2ClientConsentForCallerData,
  GetOAuth2ClientConsentForCallerErrors,
  GetOAuth2ClientConsentForCallerResponses,
  GetOAuth2ClientConsentStatusForCallerData,
  GetOAuth2ClientConsentStatusForCallerErrors,
  GetOAuth2ClientConsentStatusForCallerResponses,
  GetOAuth2ClientData,
  GetOAuth2ClientErrors,
  GetOAuth2ClientResponses,
  GetOrganizationData,
  GetOrganizationErrors,
  GetOrganizationResponses,
  GetOrganizationSettingsData,
  GetOrganizationSettingsErrors,
  GetOrganizationSettingsResponses,
  GetPersonCredentialRegistrationConfirmationData,
  GetPersonCredentialRegistrationConfirmationErrors,
  GetPersonCredentialRegistrationConfirmationResponses,
  GetProfileForCallerData,
  GetProfileForCallerErrors,
  GetProfileForCallerResponses,
  GetSubscriptionData,
  GetSubscriptionErrors,
  GetSubscriptionResponses,
  GetTenantedTestingOnlyData,
  GetTenantedTestingOnlyErrors,
  GetTenantedTestingOnlyResponses,
  GetTestingOnlyData,
  GetTestingOnlyErrors,
  GetTestingOnlyResponses,
  GetUserInfoForCallerData,
  GetUserInfoForCallerErrors,
  GetUserInfoForCallerResponses,
  GetWithRedirectTestingOnlyData,
  GetWithRedirectTestingOnlyErrors,
  GetWithRedirectTestingOnlyResponses,
  GetWithSimpleArrayTestingOnlyData,
  GetWithSimpleArrayTestingOnlyErrors,
  GetWithSimpleArrayTestingOnlyResponses,
  HealthCheckData,
  HealthCheckErrors,
  HealthCheckResponses,
  InitiatePasswordResetData,
  InitiatePasswordResetErrors,
  InitiatePasswordResetResponses,
  InviteGuestData,
  InviteGuestErrors,
  InviteGuestResponses,
  InviteMemberToOrganizationData,
  InviteMemberToOrganizationErrors,
  InviteMemberToOrganizationResponses,
  ListCredentialMfaAuthenticatorsForCallerData,
  ListCredentialMfaAuthenticatorsForCallerErrors,
  ListCredentialMfaAuthenticatorsForCallerResponses,
  ListMembersForOrganizationData,
  ListMembersForOrganizationErrors,
  ListMembersForOrganizationResponses,
  ListMembershipsForCallerData,
  ListMembershipsForCallerErrors,
  ListMembershipsForCallerResponses,
  ListPricingPlansData,
  ListPricingPlansErrors,
  ListPricingPlansResponses,
  MailgunNotifyWebhookEventData,
  MailgunNotifyWebhookEventErrors,
  MailgunNotifyWebhookEventResponses,
  MakeBookingData,
  MakeBookingErrors,
  MakeBookingResponses,
  MigrateSubscriptionPatchData,
  MigrateSubscriptionPatchErrors,
  MigrateSubscriptionPatchResponses,
  MigrateSubscriptionPutData,
  MigrateSubscriptionPutErrors,
  MigrateSubscriptionPutResponses,
  NotifyDomainEventData,
  NotifyDomainEventErrors,
  NotifyDomainEventResponses,
  NotifyFakeBillingProviderWebHookEventData,
  NotifyFakeBillingProviderWebHookEventErrors,
  NotifyFakeBillingProviderWebHookEventResponses,
  NotifyProvisioningData,
  NotifyProvisioningErrors,
  NotifyProvisioningResponses,
  OpenApiGetTestingOnlyData,
  OpenApiGetTestingOnlyErrors,
  OpenApiGetTestingOnlyResponses,
  OpenApiPostFormUrlEncodedTestingOnlyData,
  OpenApiPostFormUrlEncodedTestingOnlyErrors,
  OpenApiPostFormUrlEncodedTestingOnlyResponses,
  OpenApiPostMultiPartFormDataTestingOnlyData,
  OpenApiPostMultiPartFormDataTestingOnlyErrors,
  OpenApiPostMultiPartFormDataTestingOnlyResponses,
  OpenApiPostTestingOnlyData,
  OpenApiPostTestingOnlyErrors,
  OpenApiPostTestingOnlyResponses,
  OpenApiPutTestingOnlyPatchData,
  OpenApiPutTestingOnlyPatchErrors,
  OpenApiPutTestingOnlyPatchResponses,
  OpenApiPutTestingOnlyPutData,
  OpenApiPutTestingOnlyPutErrors,
  OpenApiPutTestingOnlyPutResponses,
  PostInsecureTestingOnlyData,
  PostInsecureTestingOnlyErrors,
  PostInsecureTestingOnlyResponses,
  PostTestingOnlyData,
  PostTestingOnlyErrors,
  PostTestingOnlyResponses,
  PostWithEmptyBodyAndRequiredPropertiesTestingOnlyData,
  PostWithEmptyBodyAndRequiredPropertiesTestingOnlyErrors,
  PostWithEmptyBodyAndRequiredPropertiesTestingOnlyResponses,
  PostWithEmptyBodyTestingOnlyData,
  PostWithEmptyBodyTestingOnlyErrors,
  PostWithEmptyBodyTestingOnlyResponses,
  PostWithRedirectTestingOnlyData,
  PostWithRedirectTestingOnlyErrors,
  PostWithRedirectTestingOnlyResponses,
  PostWithRouteParamsAndEmptyBodyTestingOnlyData,
  PostWithRouteParamsAndEmptyBodyTestingOnlyErrors,
  PostWithRouteParamsAndEmptyBodyTestingOnlyResponses,
  RecordMeasureData,
  RecordMeasureErrors,
  RecordMeasureResponses,
  RecordUseData,
  RecordUseErrors,
  RecordUseResponses,
  RefreshTokenData,
  RefreshTokenErrors,
  RefreshTokenResponses,
  RegenerateOAuth2ClientSecretData,
  RegenerateOAuth2ClientSecretErrors,
  RegenerateOAuth2ClientSecretResponses,
  RegisterCarData,
  RegisterCarErrors,
  RegisterCarResponses,
  RegisterMachineData,
  RegisterMachineErrors,
  RegisterMachineResponses,
  RegisterPersonCredentialData,
  RegisterPersonCredentialErrors,
  RegisterPersonCredentialResponses,
  RequestCorrelationsTestingOnlyData,
  RequestCorrelationsTestingOnlyErrors,
  RequestCorrelationsTestingOnlyResponses,
  ResendGuestInvitationData,
  ResendGuestInvitationErrors,
  ResendGuestInvitationResponses,
  ResendPasswordResetData,
  ResendPasswordResetErrors,
  ResendPasswordResetResponses,
  ResendPersonCredentialRegistrationConfirmationData,
  ResendPersonCredentialRegistrationConfirmationErrors,
  ResendPersonCredentialRegistrationConfirmationResponses,
  ResetCredentialMfaPatchData,
  ResetCredentialMfaPatchErrors,
  ResetCredentialMfaPatchResponses,
  ResetCredentialMfaPutData,
  ResetCredentialMfaPutErrors,
  ResetCredentialMfaPutResponses,
  RevokeApiKeyData,
  RevokeApiKeyErrors,
  RevokeApiKeyResponses,
  RevokeOAuth2ClientConsentForCallerData,
  RevokeOAuth2ClientConsentForCallerErrors,
  RevokeOAuth2ClientConsentForCallerResponses,
  RevokeRefreshTokenData,
  RevokeRefreshTokenErrors,
  RevokeRefreshTokenResponses,
  ScheduleMaintenanceCarPatchData,
  ScheduleMaintenanceCarPatchErrors,
  ScheduleMaintenanceCarPatchResponses,
  ScheduleMaintenanceCarPutData,
  ScheduleMaintenanceCarPutErrors,
  ScheduleMaintenanceCarPutResponses,
  SearchAllApiKeysForCallerData,
  SearchAllApiKeysForCallerErrors,
  SearchAllApiKeysForCallerResponses,
  SearchAllAuditsData,
  SearchAllAuditsErrors,
  SearchAllAuditsResponses,
  SearchAllAvailableCarsData,
  SearchAllAvailableCarsErrors,
  SearchAllAvailableCarsResponses,
  SearchAllBookingsData,
  SearchAllBookingsErrors,
  SearchAllBookingsResponses,
  SearchAllCarsData,
  SearchAllCarsErrors,
  SearchAllCarsResponses,
  SearchAllCarUnavailabilitiesData,
  SearchAllCarUnavailabilitiesErrors,
  SearchAllCarUnavailabilitiesResponses,
  SearchAllEmailDeliveriesData,
  SearchAllEmailDeliveriesErrors,
  SearchAllEmailDeliveriesResponses,
  SearchAllEventNotificationsData,
  SearchAllEventNotificationsErrors,
  SearchAllEventNotificationsResponses,
  SearchAllOAuth2ClientsData,
  SearchAllOAuth2ClientsErrors,
  SearchAllOAuth2ClientsResponses,
  SearchAllSmsDeliveriesData,
  SearchAllSmsDeliveriesErrors,
  SearchAllSmsDeliveriesResponses,
  SearchSubscriptionHistoryData,
  SearchSubscriptionHistoryErrors,
  SearchSubscriptionHistoryResponses,
  SearchTestingOnlyData,
  SearchTestingOnlyErrors,
  SearchTestingOnlyResponses,
  SendEmailData,
  SendEmailErrors,
  SendEmailResponses,
  SendSmsData,
  SendSmsErrors,
  SendSmsResponses,
  StatusesDeleteTestingOnlyData,
  StatusesDeleteTestingOnlyErrors,
  StatusesDeleteTestingOnlyResponses,
  StatusesDeleteWithResponseTestingOnlyData,
  StatusesDeleteWithResponseTestingOnlyErrors,
  StatusesDeleteWithResponseTestingOnlyResponses,
  StatusesGetTestingOnlyData,
  StatusesGetTestingOnlyErrors,
  StatusesGetTestingOnlyResponses,
  StatusesPostTestingOnlyData,
  StatusesPostTestingOnlyErrors,
  StatusesPostTestingOnlyResponses,
  StatusesPostWithLocationTestingOnlyData,
  StatusesPostWithLocationTestingOnlyErrors,
  StatusesPostWithLocationTestingOnlyResponses,
  StatusesPutPatchTestingOnlyPatchData,
  StatusesPutPatchTestingOnlyPatchErrors,
  StatusesPutPatchTestingOnlyPatchResponses,
  StatusesPutPatchTestingOnlyPutData,
  StatusesPutPatchTestingOnlyPutErrors,
  StatusesPutPatchTestingOnlyPutResponses,
  StatusesSearchTestingOnlyData,
  StatusesSearchTestingOnlyErrors,
  StatusesSearchTestingOnlyResponses,
  TakeOfflineCarPatchData,
  TakeOfflineCarPatchErrors,
  TakeOfflineCarPatchResponses,
  TakeOfflineCarPutData,
  TakeOfflineCarPutErrors,
  TakeOfflineCarPutResponses,
  TransferSubscriptionPatchData,
  TransferSubscriptionPatchErrors,
  TransferSubscriptionPatchResponses,
  TransferSubscriptionPutData,
  TransferSubscriptionPutErrors,
  TransferSubscriptionPutResponses,
  TwilioNotifyEmailWebhookEventData,
  TwilioNotifyEmailWebhookEventErrors,
  TwilioNotifyEmailWebhookEventResponses,
  TwilioNotifySmsWebhookEventData,
  TwilioNotifySmsWebhookEventErrors,
  TwilioNotifySmsWebhookEventResponses,
  UnassignPlatformRolesPatchData,
  UnassignPlatformRolesPatchErrors,
  UnassignPlatformRolesPatchResponses,
  UnassignPlatformRolesPutData,
  UnassignPlatformRolesPutErrors,
  UnassignPlatformRolesPutResponses,
  UnassignRolesFromOrganizationPatchData,
  UnassignRolesFromOrganizationPatchErrors,
  UnassignRolesFromOrganizationPatchResponses,
  UnassignRolesFromOrganizationPutData,
  UnassignRolesFromOrganizationPutErrors,
  UnassignRolesFromOrganizationPutResponses,
  UnInviteMemberFromOrganizationData,
  UnInviteMemberFromOrganizationErrors,
  UnInviteMemberFromOrganizationResponses,
  UpdateImagePatchData,
  UpdateImagePatchErrors,
  UpdateImagePatchResponses,
  UpdateImagePutData,
  UpdateImagePutErrors,
  UpdateImagePutResponses,
  UpdateOAuth2ClientPatchData,
  UpdateOAuth2ClientPatchErrors,
  UpdateOAuth2ClientPatchResponses,
  UpdateOAuth2ClientPutData,
  UpdateOAuth2ClientPutErrors,
  UpdateOAuth2ClientPutResponses,
  UploadImageData,
  UploadImageErrors,
  UploadImageResponses,
  ValidationsUnvalidatedTestingOnlyData,
  ValidationsUnvalidatedTestingOnlyErrors,
  ValidationsUnvalidatedTestingOnlyResponses,
  ValidationsValidatedGetTestingOnlyData,
  ValidationsValidatedGetTestingOnlyErrors,
  ValidationsValidatedGetTestingOnlyResponses,
  ValidationsValidatedPostTestingOnlyData,
  ValidationsValidatedPostTestingOnlyErrors,
  ValidationsValidatedPostTestingOnlyResponses,
  VerifyCredentialMfaAuthenticatorForCallerPatchData,
  VerifyCredentialMfaAuthenticatorForCallerPatchErrors,
  VerifyCredentialMfaAuthenticatorForCallerPatchResponses,
  VerifyCredentialMfaAuthenticatorForCallerPutData,
  VerifyCredentialMfaAuthenticatorForCallerPutErrors,
  VerifyCredentialMfaAuthenticatorForCallerPutResponses,
  VerifyGuestInvitationData,
  VerifyGuestInvitationErrors,
  VerifyGuestInvitationResponses,
  VerifyPasswordResetData,
  VerifyPasswordResetErrors,
  VerifyPasswordResetResponses
} from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Lists all the API keys for the authenticated user
 *
 * (request type: SearchAllAPIKeysForCallerRequest)
 */
export const searchAllApiKeysForCaller = <ThrowOnError extends boolean = false>(options?: Options<SearchAllApiKeysForCallerData, ThrowOnError>) => (options?.client ?? client).get<SearchAllApiKeysForCallerResponses, SearchAllApiKeysForCallerErrors, ThrowOnError>({
    responseTransformer: searchAllApiKeysForCallerResponseTransformer,
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/apikeys',
    ...options
});

/**
 * Creates a new API key for the authenticated user, and expires all exisitng API keys
 *
 * (request type: CreateAPIKeyRequest)
 */
export const createApiKey = <ThrowOnError extends boolean = false>(options?: Options<CreateApiKeyData, ThrowOnError>) => (options?.client ?? client).post<CreateApiKeyResponses, CreateApiKeyErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/apikeys',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Deletes the API key of the authenticated user
 *
 * (request type: DeleteAPIKeyRequest)
 */
export const deleteApiKey = <ThrowOnError extends boolean = false>(options: Options<DeleteApiKeyData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiKeyResponses, DeleteApiKeyErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/apikeys/{Id}',
    ...options
});

/**
 * Revokes the API key
 *
 * (request type: RevokeAPIKeyRequest)
 */
export const revokeApiKey = <ThrowOnError extends boolean = false>(options: Options<RevokeApiKeyData, ThrowOnError>) => (options.client ?? client).delete<RevokeApiKeyResponses, RevokeApiKeyErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/apikeys/{Id}/revoke',
    ...options
});

/**
 * Delivers an audit message
 *
 * (request type: DeliverAuditRequest)
 */
export const deliverAudit = <ThrowOnError extends boolean = false>(options?: Options<DeliverAuditData, ThrowOnError>) => (options?.client ?? client).post<DeliverAuditResponses, DeliverAuditErrors, ThrowOnError>({
    url: '/audits/deliver',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Drains all the pending audit messages
 *
 * (request type: DrainAllAuditsRequest)
 */
export const drainAllAudits = <ThrowOnError extends boolean = false>(options?: Options<DrainAllAuditsData, ThrowOnError>) => (options?.client ?? client).post<DrainAllAuditsResponses, DrainAllAuditsErrors, ThrowOnError>({
    url: '/audits/drain',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Lists all audits since the specified date, for the specified organization
 *
 * (request type: SearchAllAuditsRequest)
 */
export const searchAllAudits = <ThrowOnError extends boolean = false>(options?: Options<SearchAllAuditsData, ThrowOnError>) => (options?.client ?? client).get<SearchAllAuditsResponses, SearchAllAuditsErrors, ThrowOnError>({
    responseTransformer: searchAllAuditsResponseTransformer,
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/audits',
    ...options
});

/**
 * Refreshes the access_token for the specified refresh_token
 *
 * (request type: RefreshTokenRequest)
 */
export const refreshToken = <ThrowOnError extends boolean = false>(options?: Options<RefreshTokenData, ThrowOnError>) => (options?.client ?? client).post<RefreshTokenResponses, RefreshTokenErrors, ThrowOnError>({
    responseTransformer: refreshTokenResponseTransformer,
    url: '/tokens/refresh',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Revoke a valid refresh_token
 *
 * (request type: RevokeRefreshTokenRequest)
 */
export const revokeRefreshToken = <ThrowOnError extends boolean = false>(options: Options<RevokeRefreshTokenData, ThrowOnError>) => (options.client ?? client).delete<RevokeRefreshTokenResponses, RevokeRefreshTokenErrors, ThrowOnError>({ url: '/tokens/{RefreshToken}', ...options });

/**
 * Exports all the subscriptions created by the currently installed Billing Provider, that will need to be migrated by the next Billing Provider
 *
 * (request type: ExportSubscriptionsToMigrateRequest)
 */
export const exportSubscriptionsToMigrate = <ThrowOnError extends boolean = false>(options?: Options<ExportSubscriptionsToMigrateData, ThrowOnError>) => (options?.client ?? client).get<ExportSubscriptionsToMigrateResponses, ExportSubscriptionsToMigrateErrors, ThrowOnError>({ url: '/subscriptions/export', ...options });

/**
 * Migrates an existing subscription from the previously installed Billing Provider to the currently installed Billing Provider
 *
 * (request type: MigrateSubscriptionRequest)
 */
export const migrateSubscriptionPatch = <ThrowOnError extends boolean = false>(options: Options<MigrateSubscriptionPatchData, ThrowOnError>) => (options.client ?? client).patch<MigrateSubscriptionPatchResponses, MigrateSubscriptionPatchErrors, ThrowOnError>({
    url: '/subscriptions/{Id}/migrate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Migrates an existing subscription from the previously installed Billing Provider to the currently installed Billing Provider
 *
 * (request type: MigrateSubscriptionRequest)
 */
export const migrateSubscriptionPut = <ThrowOnError extends boolean = false>(options: Options<MigrateSubscriptionPutData, ThrowOnError>) => (options.client ?? client).put<MigrateSubscriptionPutResponses, MigrateSubscriptionPutErrors, ThrowOnError>({
    url: '/subscriptions/{Id}/migrate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancels a booking
 *
 * (request type: CancelBookingRequest)
 */
export const cancelBooking = <ThrowOnError extends boolean = false>(options: Options<CancelBookingData, ThrowOnError>) => (options.client ?? client).delete<CancelBookingResponses, CancelBookingErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/bookings/{Id}',
    ...options
});

/**
 * Lists all the bookings for all cars
 *
 * (request type: SearchAllBookingsRequest)
 */
export const searchAllBookings = <ThrowOnError extends boolean = false>(options?: Options<SearchAllBookingsData, ThrowOnError>) => (options?.client ?? client).get<SearchAllBookingsResponses, SearchAllBookingsErrors, ThrowOnError>({
    responseTransformer: searchAllBookingsResponseTransformer,
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/bookings',
    ...options
});

/**
 * Makes a new booking for a specific car
 *
 * (request type: MakeBookingRequest)
 */
export const makeBooking = <ThrowOnError extends boolean = false>(options?: Options<MakeBookingData, ThrowOnError>) => (options?.client ?? client).post<MakeBookingResponses, MakeBookingErrors, ThrowOnError>({
    responseTransformer: makeBookingResponseTransformer,
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/bookings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Deletes the specified car
 *
 * (request type: DeleteCarRequest)
 */
export const deleteCar = <ThrowOnError extends boolean = false>(options: Options<DeleteCarData, ThrowOnError>) => (options.client ?? client).delete<DeleteCarResponses, DeleteCarErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/cars/{Id}',
    ...options
});

/**
 * Fetches the specified car
 *
 * (request type: GetCarRequest)
 */
export const getCar = <ThrowOnError extends boolean = false>(options: Options<GetCarData, ThrowOnError>) => (options.client ?? client).get<GetCarResponses, GetCarErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/cars/{Id}',
    ...options
});

/**
 * Lists all the cars
 *
 * (request type: SearchAllCarsRequest)
 */
export const searchAllCars = <ThrowOnError extends boolean = false>(options?: Options<SearchAllCarsData, ThrowOnError>) => (options?.client ?? client).get<SearchAllCarsResponses, SearchAllCarsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/cars',
    ...options
});

/**
 * Registers a new car
 *
 * (request type: RegisterCarRequest)
 */
export const registerCar = <ThrowOnError extends boolean = false>(options?: Options<RegisterCarData, ThrowOnError>) => (options?.client ?? client).post<RegisterCarResponses, RegisterCarErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/cars',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Schedules the car for maintenance for the specified period
 *
 * (request type: ScheduleMaintenanceCarRequest)
 */
export const scheduleMaintenanceCarPatch = <ThrowOnError extends boolean = false>(options: Options<ScheduleMaintenanceCarPatchData, ThrowOnError>) => (options.client ?? client).patch<ScheduleMaintenanceCarPatchResponses, ScheduleMaintenanceCarPatchErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/cars/{Id}/maintain',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Schedules the car for maintenance for the specified period
 *
 * (request type: ScheduleMaintenanceCarRequest)
 */
export const scheduleMaintenanceCarPut = <ThrowOnError extends boolean = false>(options: Options<ScheduleMaintenanceCarPutData, ThrowOnError>) => (options.client ?? client).put<ScheduleMaintenanceCarPutResponses, ScheduleMaintenanceCarPutErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/cars/{Id}/maintain',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists all the available cars for the specified period
 *
 * (request type: SearchAllAvailableCarsRequest)
 */
export const searchAllAvailableCars = <ThrowOnError extends boolean = false>(options?: Options<SearchAllAvailableCarsData, ThrowOnError>) => (options?.client ?? client).get<SearchAllAvailableCarsResponses, SearchAllAvailableCarsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/cars/available',
    ...options
});

/**
 * Lists all the periods for when the specified car is unavailable
 *
 * (request type: SearchAllCarUnavailabilitiesRequest)
 */
export const searchAllCarUnavailabilities = <ThrowOnError extends boolean = false>(options: Options<SearchAllCarUnavailabilitiesData, ThrowOnError>) => (options.client ?? client).get<SearchAllCarUnavailabilitiesResponses, SearchAllCarUnavailabilitiesErrors, ThrowOnError>({ url: '/cars/{Id}/unavailabilities', ...options });

/**
 * Reserves the car to go offline for the specified period
 *
 * (request type: TakeOfflineCarRequest)
 */
export const takeOfflineCarPatch = <ThrowOnError extends boolean = false>(options: Options<TakeOfflineCarPatchData, ThrowOnError>) => (options.client ?? client).patch<TakeOfflineCarPatchResponses, TakeOfflineCarPatchErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/cars/{Id}/offline',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reserves the car to go offline for the specified period
 *
 * (request type: TakeOfflineCarRequest)
 */
export const takeOfflineCarPut = <ThrowOnError extends boolean = false>(options: Options<TakeOfflineCarPutData, ThrowOnError>) => (options.client ?? client).put<TakeOfflineCarPutResponses, TakeOfflineCarPutErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/cars/{Id}/offline',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Notifies a Chargebee event, via a webhook
 *
 * (request type: ChargebeeNotifyWebhookEventRequest)
 */
export const chargebeeNotifyWebhookEvent = <ThrowOnError extends boolean = false>(options?: Options<ChargebeeNotifyWebhookEventData, ThrowOnError>) => (options?.client ?? client).post<ChargebeeNotifyWebhookEventResponses, ChargebeeNotifyWebhookEventErrors, ThrowOnError>({
    url: '/webhooks/chargebee',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Removes the OAuth2 client's logo
 *
 * (request type: DeleteOAuth2ClientLogoRequest)
 */
export const deleteOAuth2ClientLogo = <ThrowOnError extends boolean = false>(options: Options<DeleteOAuth2ClientLogoData, ThrowOnError>) => (options.client ?? client).delete<DeleteOAuth2ClientLogoResponses, DeleteOAuth2ClientLogoErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/oauth2/clients/{Id}/logo',
    ...options
});

/**
 * Changes the OAuth2 client's logo
 *
 * (request type: ChangeOAuth2ClientLogoRequest)
 */
export const changeOAuth2ClientLogoPatch = <ThrowOnError extends boolean = false>(options: Options<ChangeOAuth2ClientLogoPatchData, ThrowOnError>) => (options.client ?? client).patch<ChangeOAuth2ClientLogoPatchResponses, ChangeOAuth2ClientLogoPatchErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/oauth2/clients/{Id}/logo',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Changes the OAuth2 client's logo
 *
 * (request type: ChangeOAuth2ClientLogoRequest)
 */
export const changeOAuth2ClientLogoPut = <ThrowOnError extends boolean = false>(options: Options<ChangeOAuth2ClientLogoPutData, ThrowOnError>) => (options.client ?? client).put<ChangeOAuth2ClientLogoPutResponses, ChangeOAuth2ClientLogoPutErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/oauth2/clients/{Id}/logo',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Gets the user's consent for an OAuth2/Open ID Connect client
 *
 * (request type: GetOAuth2ClientConsentForCallerRequest)
 */
export const getOAuth2ClientConsentForCaller = <ThrowOnError extends boolean = false>(options: Options<GetOAuth2ClientConsentForCallerData, ThrowOnError>) => (options.client ?? client).get<GetOAuth2ClientConsentForCallerResponses, GetOAuth2ClientConsentForCallerErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/oauth2/clients/{Id}/consent',
    ...options
});

/**
 * Consent for the user to authorize the OAuth2/Open ID Connect client to access their data
 *
 * (request type: ConsentOAuth2ClientForCallerRequest)
 */
export const consentOAuth2ClientForCaller = <ThrowOnError extends boolean = false>(options: Options<ConsentOAuth2ClientForCallerData, ThrowOnError>) => (options.client ?? client).post<ConsentOAuth2ClientForCallerResponses, ConsentOAuth2ClientForCallerErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/oauth2/clients/{Id}/consent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Lists all OAuth2/Open ID Connect clients
 *
 * (request type: SearchAllOAuth2ClientsRequest)
 */
export const searchAllOAuth2Clients = <ThrowOnError extends boolean = false>(options?: Options<SearchAllOAuth2ClientsData, ThrowOnError>) => (options?.client ?? client).get<SearchAllOAuth2ClientsResponses, SearchAllOAuth2ClientsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/oauth2/clients',
    ...options
});

/**
 * Creates a new OAuth2/Open ID Connect client application
 *
 * (request type: CreateOAuth2ClientRequest)
 */
export const createOAuth2Client = <ThrowOnError extends boolean = false>(options?: Options<CreateOAuth2ClientData, ThrowOnError>) => (options?.client ?? client).post<CreateOAuth2ClientResponses, CreateOAuth2ClientErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/oauth2/clients',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Deletes an OAuth2/Open ID Connect client
 *
 * (request type: DeleteOAuth2ClientRequest)
 */
export const deleteOAuth2Client = <ThrowOnError extends boolean = false>(options: Options<DeleteOAuth2ClientData, ThrowOnError>) => (options.client ?? client).delete<DeleteOAuth2ClientResponses, DeleteOAuth2ClientErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/oauth2/clients/{Id}',
    ...options
});

/**
 * Fetches an OAuth2/Open ID Connect client
 *
 * (request type: GetOAuth2ClientRequest)
 */
export const getOAuth2Client = <ThrowOnError extends boolean = false>(options: Options<GetOAuth2ClientData, ThrowOnError>) => (options.client ?? client).get<GetOAuth2ClientResponses, GetOAuth2ClientErrors, ThrowOnError>({
    responseTransformer: getOAuth2ClientResponseTransformer,
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/oauth2/clients/{Id}',
    ...options
});

/**
 * Updates an existing OAuth2/Open ID Connect client
 *
 * (request type: UpdateOAuth2ClientRequest)
 */
export const updateOAuth2ClientPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateOAuth2ClientPatchData, ThrowOnError>) => (options.client ?? client).patch<UpdateOAuth2ClientPatchResponses, UpdateOAuth2ClientPatchErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/oauth2/clients/{Id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Updates an existing OAuth2/Open ID Connect client
 *
 * (request type: UpdateOAuth2ClientRequest)
 */
export const updateOAuth2ClientPut = <ThrowOnError extends boolean = false>(options: Options<UpdateOAuth2ClientPutData, ThrowOnError>) => (options.client ?? client).put<UpdateOAuth2ClientPutResponses, UpdateOAuth2ClientPutErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/oauth2/clients/{Id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gets the user's consent status for an OAuth2/Open ID Connect client
 *
 * (request type: GetOAuth2ClientConsentStatusForCallerRequest)
 */
export const getOAuth2ClientConsentStatusForCaller = <ThrowOnError extends boolean = false>(options: Options<GetOAuth2ClientConsentStatusForCallerData, ThrowOnError>) => (options.client ?? client).get<GetOAuth2ClientConsentStatusForCallerResponses, GetOAuth2ClientConsentStatusForCallerErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/oauth2/clients/{Id}/consent/status',
    ...options
});

/**
 * Regenerates the client secret for an OAuth2/Open ID Connect client
 *
 * (request type: RegenerateOAuth2ClientSecretRequest)
 */
export const regenerateOAuth2ClientSecret = <ThrowOnError extends boolean = false>(options: Options<RegenerateOAuth2ClientSecretData, ThrowOnError>) => (options.client ?? client).post<RegenerateOAuth2ClientSecretResponses, RegenerateOAuth2ClientSecretErrors, ThrowOnError>({
    responseTransformer: regenerateOAuth2ClientSecretResponseTransformer,
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/oauth2/clients/{Id}/secret',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revokes the user's consent for an OAuth2/Open ID Connect client
 *
 * (request type: RevokeOAuth2ClientConsentForCallerRequest)
 */
export const revokeOAuth2ClientConsentForCaller = <ThrowOnError extends boolean = false>(options: Options<RevokeOAuth2ClientConsentForCallerData, ThrowOnError>) => (options.client ?? client).delete<RevokeOAuth2ClientConsentForCallerResponses, RevokeOAuth2ClientConsentForCallerErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/oauth2/clients/{Id}/consent/revoke',
    ...options
});

/**
 * Authenticates a user with a username and password
 *
 * (request type: AuthenticateCredentialRequest)
 */
export const authenticateCredential = <ThrowOnError extends boolean = false>(options?: Options<AuthenticateCredentialData, ThrowOnError>) => (options?.client ?? client).post<AuthenticateCredentialResponses, AuthenticateCredentialErrors, ThrowOnError>({
    responseTransformer: authenticateCredentialResponseTransformer,
    url: '/credentials/auth',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Completes a password reset attempt
 *
 * (request type: CompletePasswordResetRequest)
 */
export const completePasswordReset = <ThrowOnError extends boolean = false>(options: Options<CompletePasswordResetData, ThrowOnError>) => (options.client ?? client).post<CompletePasswordResetResponses, CompletePasswordResetErrors, ThrowOnError>({
    url: '/credentials/{Token}/reset/complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Fetches the confirmation token for a registration of a person
 *
 * (request type: GetPersonCredentialRegistrationConfirmationRequest)
 */
export const getPersonCredentialRegistrationConfirmation = <ThrowOnError extends boolean = false>(options: Options<GetPersonCredentialRegistrationConfirmationData, ThrowOnError>) => (options.client ?? client).get<GetPersonCredentialRegistrationConfirmationResponses, GetPersonCredentialRegistrationConfirmationErrors, ThrowOnError>({ url: '/credentials/confirm-registration', ...options });

/**
 * Confirms the registration of a new person (verifying their email address)
 *
 * (request type: ConfirmPersonCredentialRegistrationRequest)
 */
export const confirmPersonCredentialRegistration = <ThrowOnError extends boolean = false>(options?: Options<ConfirmPersonCredentialRegistrationData, ThrowOnError>) => (options?.client ?? client).post<ConfirmPersonCredentialRegistrationResponses, ConfirmPersonCredentialRegistrationErrors, ThrowOnError>({
    url: '/credentials/confirm-registration',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Renews and resends a confirmation email for confirming the registration of a person
 *
 * (request type: ResendPersonCredentialRegistrationConfirmationRequest)
 */
export const resendPersonCredentialRegistrationConfirmation = <ThrowOnError extends boolean = false>(options?: Options<ResendPersonCredentialRegistrationConfirmationData, ThrowOnError>) => (options?.client ?? client).post<ResendPersonCredentialRegistrationConfirmationResponses, ResendPersonCredentialRegistrationConfirmationErrors, ThrowOnError>({
    url: '/credentials/resend-confirmation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Registers a new person on the platform
 *
 * (request type: RegisterPersonCredentialRequest)
 */
export const registerPersonCredential = <ThrowOnError extends boolean = false>(options?: Options<RegisterPersonCredentialData, ThrowOnError>) => (options?.client ?? client).post<RegisterPersonCredentialResponses, RegisterPersonCredentialErrors, ThrowOnError>({
    url: '/credentials/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Begins a password reset attempt
 *
 * (request type: InitiatePasswordResetRequest)
 */
export const initiatePasswordReset = <ThrowOnError extends boolean = false>(options?: Options<InitiatePasswordResetData, ThrowOnError>) => (options?.client ?? client).post<InitiatePasswordResetResponses, InitiatePasswordResetErrors, ThrowOnError>({
    url: '/credentials/reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Resends a password reset attempt (via email)
 *
 * (request type: ResendPasswordResetRequest)
 */
export const resendPasswordReset = <ThrowOnError extends boolean = false>(options: Options<ResendPasswordResetData, ThrowOnError>) => (options.client ?? client).post<ResendPasswordResetResponses, ResendPasswordResetErrors, ThrowOnError>({
    url: '/credentials/{Token}/reset/resend',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verifies that the password reset attempt is still valid
 *
 * (request type: VerifyPasswordResetRequest)
 */
export const verifyPasswordReset = <ThrowOnError extends boolean = false>(options: Options<VerifyPasswordResetData, ThrowOnError>) => (options.client ?? client).get<VerifyPasswordResetResponses, VerifyPasswordResetErrors, ThrowOnError>({ url: '/credentials/{Token}/reset/verify', ...options });

/**
 * Drains all the pending event notifications
 *
 * (request type: DrainAllEventNotificationsRequest)
 */
export const drainAllEventNotifications = <ThrowOnError extends boolean = false>(options?: Options<DrainAllEventNotificationsData, ThrowOnError>) => (options?.client ?? client).post<DrainAllEventNotificationsResponses, DrainAllEventNotificationsErrors, ThrowOnError>({
    url: '/event_notifications/drain',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Lists all event notifications
 *
 * (request type: SearchAllEventNotificationsRequest)
 */
export const searchAllEventNotifications = <ThrowOnError extends boolean = false>(options?: Options<SearchAllEventNotificationsData, ThrowOnError>) => (options?.client ?? client).get<SearchAllEventNotificationsResponses, SearchAllEventNotificationsErrors, ThrowOnError>({
    responseTransformer: searchAllEventNotificationsResponseTransformer,
    url: '/event_notifications',
    ...options
});

/**
 * Notifies when a domain_event has been raised to a subscriber
 *
 * (request type: NotifyDomainEventRequest)
 */
export const notifyDomainEvent = <ThrowOnError extends boolean = false>(options?: Options<NotifyDomainEventData, ThrowOnError>) => (options?.client ?? client).post<NotifyDomainEventResponses, NotifyDomainEventErrors, ThrowOnError>({
    url: '/event_notifications',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Confirms the delivery of a sent email message
 *
 * (request type: ConfirmEmailDeliveredRequest)
 */
export const confirmEmailDelivered = <ThrowOnError extends boolean = false>(options?: Options<ConfirmEmailDeliveredData, ThrowOnError>) => (options?.client ?? client).post<ConfirmEmailDeliveredResponses, ConfirmEmailDeliveredErrors, ThrowOnError>({
    url: '/emails/delivered',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Confirms the failed delivery of a sent email message
 *
 * (request type: ConfirmEmailDeliveryFailedRequest)
 */
export const confirmEmailDeliveryFailed = <ThrowOnError extends boolean = false>(options?: Options<ConfirmEmailDeliveryFailedData, ThrowOnError>) => (options?.client ?? client).post<ConfirmEmailDeliveryFailedResponses, ConfirmEmailDeliveryFailedErrors, ThrowOnError>({
    url: '/emails/failed',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Drains all the pending email messages
 *
 * (request type: DrainAllEmailsRequest)
 */
export const drainAllEmails = <ThrowOnError extends boolean = false>(options?: Options<DrainAllEmailsData, ThrowOnError>) => (options?.client ?? client).post<DrainAllEmailsResponses, DrainAllEmailsErrors, ThrowOnError>({
    url: '/emails/drain',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Lists all email deliveries since the specified date, for the specified timeframe, organization and tags
 *
 * (request type: SearchAllEmailDeliveriesRequest)
 */
export const searchAllEmailDeliveries = <ThrowOnError extends boolean = false>(options?: Options<SearchAllEmailDeliveriesData, ThrowOnError>) => (options?.client ?? client).get<SearchAllEmailDeliveriesResponses, SearchAllEmailDeliveriesErrors, ThrowOnError>({
    responseTransformer: searchAllEmailDeliveriesResponseTransformer,
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/emails',
    ...options
});

/**
 * Sends an email message for delivery
 *
 * (request type: SendEmailRequest)
 */
export const sendEmail = <ThrowOnError extends boolean = false>(options?: Options<SendEmailData, ThrowOnError>) => (options?.client ?? client).post<SendEmailResponses, SendEmailErrors, ThrowOnError>({
    url: '/emails/send',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Removes the specified roles from the specified user
 *
 * (request type: UnassignPlatformRolesRequest)
 */
export const unassignPlatformRolesPatch = <ThrowOnError extends boolean = false>(options: Options<UnassignPlatformRolesPatchData, ThrowOnError>) => (options.client ?? client).patch<UnassignPlatformRolesPatchResponses, UnassignPlatformRolesPatchErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/users/{Id}/roles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Assigns the specified roles to the specified user
 *
 * (request type: AssignPlatformRolesRequest)
 */
export const assignPlatformRoles = <ThrowOnError extends boolean = false>(options: Options<AssignPlatformRolesData, ThrowOnError>) => (options.client ?? client).post<AssignPlatformRolesResponses, AssignPlatformRolesErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/users/{Id}/roles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Removes the specified roles from the specified user
 *
 * (request type: UnassignPlatformRolesRequest)
 */
export const unassignPlatformRolesPut = <ThrowOnError extends boolean = false>(options: Options<UnassignPlatformRolesPutData, ThrowOnError>) => (options.client ?? client).put<UnassignPlatformRolesPutResponses, UnassignPlatformRolesPutErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/users/{Id}/roles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Notifies when a fake billing provider backend event has occurred, and calls us to notify of it
 *
 * (request type: NotifyFakeBillingProviderWebHookEventRequest)
 */
export const notifyFakeBillingProviderWebHookEvent = <ThrowOnError extends boolean = false>(options?: Options<NotifyFakeBillingProviderWebHookEventData, ThrowOnError>) => (options?.client ?? client).post<NotifyFakeBillingProviderWebHookEventResponses, NotifyFakeBillingProviderWebHookEventErrors, ThrowOnError>({
    url: '/webhooks/providers/billing/fake',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Fetches the named feature flag, for all users, or for a specific user, and optionally for a specific tenancy
 *
 * (request type: GetFeatureFlagRequest)
 */
export const getFeatureFlag = <ThrowOnError extends boolean = false>(options: Options<GetFeatureFlagData, ThrowOnError>) => (options.client ?? client).get<GetFeatureFlagResponses, GetFeatureFlagErrors, ThrowOnError>({ url: '/flags/{UserId}/{Name}', ...options });

/**
 * Lists all the available feature flags
 *
 * (request type: GetAllFeatureFlagsRequest)
 */
export const getAllFeatureFlags = <ThrowOnError extends boolean = false>(options?: Options<GetAllFeatureFlagsData, ThrowOnError>) => (options?.client ?? client).get<GetAllFeatureFlagsResponses, GetAllFeatureFlagsErrors, ThrowOnError>({ url: '/flags', ...options });

/**
 * Fetches the named feature flag for the current authenticated user
 *
 * (request type: GetFeatureFlagForCallerRequest)
 */
export const getFeatureFlagForCaller = <ThrowOnError extends boolean = false>(options: Options<GetFeatureFlagForCallerData, ThrowOnError>) => (options.client ?? client).get<GetFeatureFlagForCallerResponses, GetFeatureFlagForCallerErrors, ThrowOnError>({ url: '/flags/{Name}', ...options });

/**
 * Displays the health of the API
 *
 * (request type: HealthCheckRequest)
 */
export const healthCheck = <ThrowOnError extends boolean = false>(options?: Options<HealthCheckData, ThrowOnError>) => (options?.client ?? client).get<HealthCheckResponses, HealthCheckErrors, ThrowOnError>({ url: '/health', ...options });

/**
 * Fetches identity details of the user
 *
 * (request type: GetIdentityForCallerRequest)
 */
export const getIdentityForCaller = <ThrowOnError extends boolean = false>(options?: Options<GetIdentityForCallerData, ThrowOnError>) => (options?.client ?? client).get<GetIdentityForCallerResponses, GetIdentityForCallerErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/users/me',
    ...options
});

/**
 * Deletes the image
 *
 * (request type: DeleteImageRequest)
 */
export const deleteImage = <ThrowOnError extends boolean = false>(options: Options<DeleteImageData, ThrowOnError>) => (options.client ?? client).delete<DeleteImageResponses, DeleteImageErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/images/{Id}',
    ...options
});

/**
 * Fetches the details about the image
 *
 * (request type: GetImageRequest)
 */
export const getImage = <ThrowOnError extends boolean = false>(options: Options<GetImageData, ThrowOnError>) => (options.client ?? client).get<GetImageResponses, GetImageErrors, ThrowOnError>({ url: '/images/{Id}', ...options });

/**
 * Changes the image details
 *
 * (request type: UpdateImageRequest)
 */
export const updateImagePatch = <ThrowOnError extends boolean = false>(options: Options<UpdateImagePatchData, ThrowOnError>) => (options.client ?? client).patch<UpdateImagePatchResponses, UpdateImagePatchErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/images/{Id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Changes the image details
 *
 * (request type: UpdateImageRequest)
 */
export const updateImagePut = <ThrowOnError extends boolean = false>(options: Options<UpdateImagePutData, ThrowOnError>) => (options.client ?? client).put<UpdateImagePutResponses, UpdateImagePutErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/images/{Id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Downloads the raw image
 *
 * (request type: DownloadImageRequest)
 */
export const downloadImage = <ThrowOnError extends boolean = false>(options: Options<DownloadImageData, ThrowOnError>) => (options.client ?? client).get<DownloadImageResponses, DownloadImageErrors, ThrowOnError>({ url: '/images/{Id}/download', ...options });

/**
 * Uploads a new image. Can be one of the following types: jpg, jpeg, png, gif
 *
 * (request type: UploadImageRequest)
 */
export const uploadImage = <ThrowOnError extends boolean = false>(options?: Options<UploadImageData, ThrowOnError>) => (options?.client ?? client).post<UploadImageResponses, UploadImageErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/images',
    ...options,
    headers: {
        'Content-Type': null,
        ...options?.headers
    }
});

/**
 * Invites the specified person (via email address) to the platform
 *
 * (request type: InviteGuestRequest)
 */
export const inviteGuest = <ThrowOnError extends boolean = false>(options?: Options<InviteGuestData, ThrowOnError>) => (options?.client ?? client).post<InviteGuestResponses, InviteGuestErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/invitations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Resends the invitation to the specified person to the platform
 *
 * (request type: ResendGuestInvitationRequest)
 */
export const resendGuestInvitation = <ThrowOnError extends boolean = false>(options: Options<ResendGuestInvitationData, ThrowOnError>) => (options.client ?? client).post<ResendGuestInvitationResponses, ResendGuestInvitationErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/invitations/{Token}/resend',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verifies that the guest invitation is still valid
 *
 * (request type: VerifyGuestInvitationRequest)
 */
export const verifyGuestInvitation = <ThrowOnError extends boolean = false>(options: Options<VerifyGuestInvitationData, ThrowOnError>) => (options.client ?? client).get<VerifyGuestInvitationResponses, VerifyGuestInvitationErrors, ThrowOnError>({ url: '/invitations/{Token}/verify', ...options });

/**
 * Register a new machine user on the platform
 *
 * (request type: RegisterMachineRequest)
 */
export const registerMachine = <ThrowOnError extends boolean = false>(options?: Options<RegisterMachineData, ThrowOnError>) => (options?.client ?? client).post<RegisterMachineResponses, RegisterMachineErrors, ThrowOnError>({
    responseTransformer: registerMachineResponseTransformer,
    url: '/machines/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Notifies a Mailgun event, via a webhook
 *
 * (request type: MailgunNotifyWebhookEventRequest)
 */
export const mailgunNotifyWebhookEvent = <ThrowOnError extends boolean = false>(options?: Options<MailgunNotifyWebhookEventData, ThrowOnError>) => (options?.client ?? client).post<MailgunNotifyWebhookEventResponses, MailgunNotifyWebhookEventErrors, ThrowOnError>({
    url: '/webhooks/mailgun',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Changes the default organization for the authenticated user
 *
 * (request type: ChangeDefaultOrganizationRequest)
 */
export const changeDefaultOrganizationPatch = <ThrowOnError extends boolean = false>(options?: Options<ChangeDefaultOrganizationPatchData, ThrowOnError>) => (options?.client ?? client).patch<ChangeDefaultOrganizationPatchResponses, ChangeDefaultOrganizationPatchErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/memberships/me/default',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Changes the default organization for the authenticated user
 *
 * (request type: ChangeDefaultOrganizationRequest)
 */
export const changeDefaultOrganizationPut = <ThrowOnError extends boolean = false>(options?: Options<ChangeDefaultOrganizationPutData, ThrowOnError>) => (options?.client ?? client).put<ChangeDefaultOrganizationPutResponses, ChangeDefaultOrganizationPutErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/memberships/me/default',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * List the memberships for the authenticated user
 *
 * (request type: ListMembershipsForCallerRequest)
 */
export const listMembershipsForCaller = <ThrowOnError extends boolean = false>(options?: Options<ListMembershipsForCallerData, ThrowOnError>) => (options?.client ?? client).get<ListMembershipsForCallerResponses, ListMembershipsForCallerErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/memberships/me',
    ...options
});

/**
 * Fetches the MFA authenticators for the user
 *
 * (request type: ListCredentialMfaAuthenticatorsForCallerRequest)
 */
export const listCredentialMfaAuthenticatorsForCaller = <ThrowOnError extends boolean = false>(options?: Options<ListCredentialMfaAuthenticatorsForCallerData, ThrowOnError>) => (options?.client ?? client).get<ListCredentialMfaAuthenticatorsForCallerResponses, ListCredentialMfaAuthenticatorsForCallerErrors, ThrowOnError>({ url: '/credentials/mfa/authenticators', ...options });

/**
 * Associates another MFA authentication factor to the user. Depending on the specific authenticator, this can send an SMS or email to the user containing a secret code.
 *
 * (request type: AssociateCredentialMfaAuthenticatorForCallerRequest)
 */
export const associateCredentialMfaAuthenticatorForCaller = <ThrowOnError extends boolean = false>(options?: Options<AssociateCredentialMfaAuthenticatorForCallerData, ThrowOnError>) => (options?.client ?? client).post<AssociateCredentialMfaAuthenticatorForCallerResponses, AssociateCredentialMfaAuthenticatorForCallerErrors, ThrowOnError>({
    url: '/credentials/mfa/authenticators',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Challenges an MFA authenticator for the user. Depending on the specific authenticator, this can send an SMS or email to the user containing a secret code.
 *
 * (request type: ChallengeCredentialMfaAuthenticatorForCallerRequest)
 */
export const challengeCredentialMfaAuthenticatorForCallerPatch = <ThrowOnError extends boolean = false>(options: Options<ChallengeCredentialMfaAuthenticatorForCallerPatchData, ThrowOnError>) => (options.client ?? client).patch<ChallengeCredentialMfaAuthenticatorForCallerPatchResponses, ChallengeCredentialMfaAuthenticatorForCallerPatchErrors, ThrowOnError>({
    url: '/credentials/mfa/authenticators/{AuthenticatorId}/challenge',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Challenges an MFA authenticator for the user. Depending on the specific authenticator, this can send an SMS or email to the user containing a secret code.
 *
 * (request type: ChallengeCredentialMfaAuthenticatorForCallerRequest)
 */
export const challengeCredentialMfaAuthenticatorForCallerPut = <ThrowOnError extends boolean = false>(options: Options<ChallengeCredentialMfaAuthenticatorForCallerPutData, ThrowOnError>) => (options.client ?? client).put<ChallengeCredentialMfaAuthenticatorForCallerPutResponses, ChallengeCredentialMfaAuthenticatorForCallerPutErrors, ThrowOnError>({
    url: '/credentials/mfa/authenticators/{AuthenticatorId}/challenge',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Changes whether the user is MFA enabled or not
 *
 * (request type: ChangeCredentialMfaForCallerRequest)
 */
export const changeCredentialMfaForCallerPatch = <ThrowOnError extends boolean = false>(options?: Options<ChangeCredentialMfaForCallerPatchData, ThrowOnError>) => (options?.client ?? client).patch<ChangeCredentialMfaForCallerPatchResponses, ChangeCredentialMfaForCallerPatchErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/credentials/mfa',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Changes whether the user is MFA enabled or not
 *
 * (request type: ChangeCredentialMfaForCallerRequest)
 */
export const changeCredentialMfaForCallerPut = <ThrowOnError extends boolean = false>(options?: Options<ChangeCredentialMfaForCallerPutData, ThrowOnError>) => (options?.client ?? client).put<ChangeCredentialMfaForCallerPutResponses, ChangeCredentialMfaForCallerPutErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/credentials/mfa',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Confirms the association of an MFA authenticator for the user, and authenticates the user.
 *
 * (request type: ConfirmCredentialMfaAuthenticatorForCallerRequest)
 */
export const confirmCredentialMfaAuthenticatorForCallerPatch = <ThrowOnError extends boolean = false>(options: Options<ConfirmCredentialMfaAuthenticatorForCallerPatchData, ThrowOnError>) => (options.client ?? client).patch<ConfirmCredentialMfaAuthenticatorForCallerPatchResponses, ConfirmCredentialMfaAuthenticatorForCallerPatchErrors, ThrowOnError>({
    responseTransformer: confirmCredentialMfaAuthenticatorForCallerPatchResponseTransformer,
    url: '/credentials/mfa/authenticators/{AuthenticatorType}/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirms the association of an MFA authenticator for the user, and authenticates the user.
 *
 * (request type: ConfirmCredentialMfaAuthenticatorForCallerRequest)
 */
export const confirmCredentialMfaAuthenticatorForCallerPut = <ThrowOnError extends boolean = false>(options: Options<ConfirmCredentialMfaAuthenticatorForCallerPutData, ThrowOnError>) => (options.client ?? client).put<ConfirmCredentialMfaAuthenticatorForCallerPutResponses, ConfirmCredentialMfaAuthenticatorForCallerPutErrors, ThrowOnError>({
    responseTransformer: confirmCredentialMfaAuthenticatorForCallerPutResponseTransformer,
    url: '/credentials/mfa/authenticators/{AuthenticatorType}/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Disassociates an associated MFA authenticator from the user
 *
 * (request type: DisassociateCredentialMfaAuthenticatorForCallerRequest)
 */
export const disassociateCredentialMfaAuthenticatorForCaller = <ThrowOnError extends boolean = false>(options: Options<DisassociateCredentialMfaAuthenticatorForCallerData, ThrowOnError>) => (options.client ?? client).delete<DisassociateCredentialMfaAuthenticatorForCallerResponses, DisassociateCredentialMfaAuthenticatorForCallerErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/credentials/mfa/authenticators/{Id}',
    ...options
});

/**
 * Resets the user MFA status back to the default for all users
 *
 * (request type: ResetCredentialMfaRequest)
 */
export const resetCredentialMfaPatch = <ThrowOnError extends boolean = false>(options?: Options<ResetCredentialMfaPatchData, ThrowOnError>) => (options?.client ?? client).patch<ResetCredentialMfaPatchResponses, ResetCredentialMfaPatchErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/credentials/mfa/reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Resets the user MFA status back to the default for all users
 *
 * (request type: ResetCredentialMfaRequest)
 */
export const resetCredentialMfaPut = <ThrowOnError extends boolean = false>(options?: Options<ResetCredentialMfaPutData, ThrowOnError>) => (options?.client ?? client).put<ResetCredentialMfaPutResponses, ResetCredentialMfaPutErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/credentials/mfa/reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Verifies an MFA authenticator for the user, and authenticates the user.
 *
 * (request type: VerifyCredentialMfaAuthenticatorForCallerRequest)
 */
export const verifyCredentialMfaAuthenticatorForCallerPatch = <ThrowOnError extends boolean = false>(options: Options<VerifyCredentialMfaAuthenticatorForCallerPatchData, ThrowOnError>) => (options.client ?? client).patch<VerifyCredentialMfaAuthenticatorForCallerPatchResponses, VerifyCredentialMfaAuthenticatorForCallerPatchErrors, ThrowOnError>({
    responseTransformer: verifyCredentialMfaAuthenticatorForCallerPatchResponseTransformer,
    url: '/credentials/mfa/authenticators/{AuthenticatorType}/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verifies an MFA authenticator for the user, and authenticates the user.
 *
 * (request type: VerifyCredentialMfaAuthenticatorForCallerRequest)
 */
export const verifyCredentialMfaAuthenticatorForCallerPut = <ThrowOnError extends boolean = false>(options: Options<VerifyCredentialMfaAuthenticatorForCallerPutData, ThrowOnError>) => (options.client ?? client).put<VerifyCredentialMfaAuthenticatorForCallerPutResponses, VerifyCredentialMfaAuthenticatorForCallerPutErrors, ThrowOnError>({
    responseTransformer: verifyCredentialMfaAuthenticatorForCallerPutResponseTransformer,
    url: '/credentials/mfa/authenticators/{AuthenticatorType}/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Authorizes the user to access the application in Open ID Connect
 *
 * (request type: AuthorizeOAuth2Request)
 */
export const authorizeOAuth2 = <ThrowOnError extends boolean = false>(options?: Options<AuthorizeOAuth2Data, ThrowOnError>) => (options?.client ?? client).post<AuthorizeOAuth2Responses, AuthorizeOAuth2Errors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    url: '/oauth2/authorize',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options?.headers
    }
});

/**
 * Exchanges either an authorization code for new tokens, or a refresh_token for new tokens, for the specified grant_type in Open ID Connect
 *
 * (request type: ExchangeOAuth2ForTokensRequest)
 */
export const exchangeOAuth2ForTokens = <ThrowOnError extends boolean = false>(options?: Options<ExchangeOAuth2ForTokensData, ThrowOnError>) => (options?.client ?? client).post<ExchangeOAuth2ForTokensResponses, ExchangeOAuth2ForTokensErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    url: '/oauth2/token',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options?.headers
    }
});

/**
 * Fetches the user's info for the authenticated user in Open ID Connect format
 *
 * (request type: GetUserInfoForCallerRequest)
 */
export const getUserInfoForCaller = <ThrowOnError extends boolean = false>(options?: Options<GetUserInfoForCallerData, ThrowOnError>) => (options?.client ?? client).get<GetUserInfoForCallerResponses, GetUserInfoForCallerErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/oauth2/userinfo',
    ...options
});

/**
 * Fetches the discovery document for Open ID Connect
 *
 * (request type: GetDiscoveryDocumentRequest)
 */
export const getDiscoveryDocument = <ThrowOnError extends boolean = false>(options?: Options<GetDiscoveryDocumentData, ThrowOnError>) => (options?.client ?? client).get<GetDiscoveryDocumentResponses, GetDiscoveryDocumentErrors, ThrowOnError>({ url: '/.well-known/openid-configuration', ...options });

/**
 * Fetches the JSON Web Key Set for Open ID Connect JWT verification
 *
 * (request type: GetJsonWebKeySetRequest)
 */
export const getJsonWebKeySet = <ThrowOnError extends boolean = false>(options?: Options<GetJsonWebKeySetData, ThrowOnError>) => (options?.client ?? client).get<GetJsonWebKeySetResponses, GetJsonWebKeySetErrors, ThrowOnError>({ url: '/.well-known/jwks.json', ...options });

/**
 * Assigns a list of roles to a member of an organization
 *
 * (request type: AssignRolesToOrganizationRequest)
 */
export const assignRolesToOrganizationPatch = <ThrowOnError extends boolean = false>(options: Options<AssignRolesToOrganizationPatchData, ThrowOnError>) => (options.client ?? client).patch<AssignRolesToOrganizationPatchResponses, AssignRolesToOrganizationPatchErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/organizations/{Id}/roles/assign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Assigns a list of roles to a member of an organization
 *
 * (request type: AssignRolesToOrganizationRequest)
 */
export const assignRolesToOrganizationPut = <ThrowOnError extends boolean = false>(options: Options<AssignRolesToOrganizationPutData, ThrowOnError>) => (options.client ?? client).put<AssignRolesToOrganizationPutResponses, AssignRolesToOrganizationPutErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/organizations/{Id}/roles/assign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Removes the avatar of the organization
 *
 * (request type: DeleteOrganizationAvatarRequest)
 */
export const deleteOrganizationAvatar = <ThrowOnError extends boolean = false>(options: Options<DeleteOrganizationAvatarData, ThrowOnError>) => (options.client ?? client).delete<DeleteOrganizationAvatarResponses, DeleteOrganizationAvatarErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/organizations/{Id}/avatar',
    ...options
});

/**
 * Uploads a new avatar for the organization
 *
 * (request type: ChangeOrganizationAvatarRequest)
 */
export const changeOrganizationAvatarPatch = <ThrowOnError extends boolean = false>(options: Options<ChangeOrganizationAvatarPatchData, ThrowOnError>) => (options.client ?? client).patch<ChangeOrganizationAvatarPatchResponses, ChangeOrganizationAvatarPatchErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/organizations/{Id}/avatar',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Uploads a new avatar for the organization
 *
 * (request type: ChangeOrganizationAvatarRequest)
 */
export const changeOrganizationAvatarPut = <ThrowOnError extends boolean = false>(options: Options<ChangeOrganizationAvatarPutData, ThrowOnError>) => (options.client ?? client).put<ChangeOrganizationAvatarPutResponses, ChangeOrganizationAvatarPutErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/organizations/{Id}/avatar',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Deletes the organization
 *
 * (request type: DeleteOrganizationRequest)
 */
export const deleteOrganization = <ThrowOnError extends boolean = false>(options: Options<DeleteOrganizationData, ThrowOnError>) => (options.client ?? client).delete<DeleteOrganizationResponses, DeleteOrganizationErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/organizations/{Id}',
    ...options
});

/**
 * Fetches the profile of the organization
 *
 * (request type: GetOrganizationRequest)
 */
export const getOrganization = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationData, ThrowOnError>) => (options.client ?? client).get<GetOrganizationResponses, GetOrganizationErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/organizations/{Id}',
    ...options
});

/**
 * Changes the profile of the organization
 *
 * (request type: ChangeOrganizationRequest)
 */
export const changeOrganizationPatch = <ThrowOnError extends boolean = false>(options: Options<ChangeOrganizationPatchData, ThrowOnError>) => (options.client ?? client).patch<ChangeOrganizationPatchResponses, ChangeOrganizationPatchErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/organizations/{Id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Changes the profile of the organization
 *
 * (request type: ChangeOrganizationRequest)
 */
export const changeOrganizationPut = <ThrowOnError extends boolean = false>(options: Options<ChangeOrganizationPutData, ThrowOnError>) => (options.client ?? client).put<ChangeOrganizationPutResponses, ChangeOrganizationPutErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/organizations/{Id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Creates a new organization to share with other users
 *
 * (request type: CreateOrganizationRequest)
 */
export const createOrganization = <ThrowOnError extends boolean = false>(options?: Options<CreateOrganizationData, ThrowOnError>) => (options?.client ?? client).post<CreateOrganizationResponses, CreateOrganizationErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/organizations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Fetches the settings for an organization
 *
 * (request type: GetOrganizationSettingsRequest)
 */
export const getOrganizationSettings = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationSettingsData, ThrowOnError>) => (options.client ?? client).get<GetOrganizationSettingsResponses, GetOrganizationSettingsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/organizations/{Id}/settings',
    ...options
});

/**
 * Fetches all the members of the organization
 *
 * (request type: ListMembersForOrganizationRequest)
 */
export const listMembersForOrganization = <ThrowOnError extends boolean = false>(options: Options<ListMembersForOrganizationData, ThrowOnError>) => (options.client ?? client).get<ListMembersForOrganizationResponses, ListMembersForOrganizationErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/organizations/{Id}/members',
    ...options
});

/**
 * Invites a new member to the organization, either by email address, or by their user ID (if known)
 *
 * (request type: InviteMemberToOrganizationRequest)
 */
export const inviteMemberToOrganization = <ThrowOnError extends boolean = false>(options: Options<InviteMemberToOrganizationData, ThrowOnError>) => (options.client ?? client).post<InviteMemberToOrganizationResponses, InviteMemberToOrganizationErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/organizations/{Id}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unassigns the list of roles from a member of an organization
 *
 * (request type: UnassignRolesFromOrganizationRequest)
 */
export const unassignRolesFromOrganizationPatch = <ThrowOnError extends boolean = false>(options: Options<UnassignRolesFromOrganizationPatchData, ThrowOnError>) => (options.client ?? client).patch<UnassignRolesFromOrganizationPatchResponses, UnassignRolesFromOrganizationPatchErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/organizations/{Id}/roles/unassign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unassigns the list of roles from a member of an organization
 *
 * (request type: UnassignRolesFromOrganizationRequest)
 */
export const unassignRolesFromOrganizationPut = <ThrowOnError extends boolean = false>(options: Options<UnassignRolesFromOrganizationPutData, ThrowOnError>) => (options.client ?? client).put<UnassignRolesFromOrganizationPutResponses, UnassignRolesFromOrganizationPutErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/organizations/{Id}/roles/unassign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Removes a previously invited member from the organization
 *
 * (request type: UnInviteMemberFromOrganizationRequest)
 */
export const unInviteMemberFromOrganization = <ThrowOnError extends boolean = false>(options: Options<UnInviteMemberFromOrganizationData, ThrowOnError>) => (options.client ?? client).delete<UnInviteMemberFromOrganizationResponses, UnInviteMemberFromOrganizationErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/organizations/{Id}/members/{UserId}',
    ...options
});

/**
 * List all the pricing plans available for this product
 *
 * (request type: ListPricingPlansRequest)
 */
export const listPricingPlans = <ThrowOnError extends boolean = false>(options?: Options<ListPricingPlansData, ThrowOnError>) => (options?.client ?? client).get<ListPricingPlansResponses, ListPricingPlansErrors, ThrowOnError>({ url: '/pricing/plans', ...options });

/**
 * Drains all the pending provisioning messages
 *
 * (request type: DrainAllProvisioningsRequest)
 */
export const drainAllProvisionings = <ThrowOnError extends boolean = false>(options?: Options<DrainAllProvisioningsData, ThrowOnError>) => (options?.client ?? client).post<DrainAllProvisioningsResponses, DrainAllProvisioningsErrors, ThrowOnError>({
    url: '/provisioning/drain',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Notifies when provisioning of a service has been completed
 *
 * (request type: NotifyProvisioningRequest)
 */
export const notifyProvisioning = <ThrowOnError extends boolean = false>(options?: Options<NotifyProvisioningData, ThrowOnError>) => (options?.client ?? client).post<NotifyProvisioningResponses, NotifyProvisioningErrors, ThrowOnError>({
    url: '/provisioning/notify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Measures an event in the product
 *
 * (request type: RecordMeasureRequest)
 */
export const recordMeasure = <ThrowOnError extends boolean = false>(options?: Options<RecordMeasureData, ThrowOnError>) => (options?.client ?? client).post<RecordMeasureResponses, RecordMeasureErrors, ThrowOnError>({
    url: '/record/measure',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Records a usage of the product
 *
 * (request type: RecordUseRequest)
 */
export const recordUse = <ThrowOnError extends boolean = false>(options?: Options<RecordUseData, ThrowOnError>) => (options?.client ?? client).post<RecordUseResponses, RecordUseErrors, ThrowOnError>({
    url: '/record/use',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Authenticates a user with authorization code from a OAuth2 or Open ID Connect single sign-on provider, and auto-registering them the first time
 *
 * (request type: AuthenticateSingleSignOnRequest)
 */
export const authenticateSingleSignOn = <ThrowOnError extends boolean = false>(options?: Options<AuthenticateSingleSignOnData, ThrowOnError>) => (options?.client ?? client).post<AuthenticateSingleSignOnResponses, AuthenticateSingleSignOnErrors, ThrowOnError>({
    responseTransformer: authenticateSingleSignOnResponseTransformer,
    url: '/sso/auth',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Confirms the delivery of a sent SMS message
 *
 * (request type: ConfirmSmsDeliveredRequest)
 */
export const confirmSmsDelivered = <ThrowOnError extends boolean = false>(options?: Options<ConfirmSmsDeliveredData, ThrowOnError>) => (options?.client ?? client).post<ConfirmSmsDeliveredResponses, ConfirmSmsDeliveredErrors, ThrowOnError>({
    url: '/smses/delivered',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Confirms the failed delivery of a sent SMS message
 *
 * (request type: ConfirmSmsDeliveryFailedRequest)
 */
export const confirmSmsDeliveryFailed = <ThrowOnError extends boolean = false>(options?: Options<ConfirmSmsDeliveryFailedData, ThrowOnError>) => (options?.client ?? client).post<ConfirmSmsDeliveryFailedResponses, ConfirmSmsDeliveryFailedErrors, ThrowOnError>({
    url: '/smses/failed',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Drains all the pending SMS messages
 *
 * (request type: DrainAllSmsesRequest)
 */
export const drainAllSmses = <ThrowOnError extends boolean = false>(options?: Options<DrainAllSmsesData, ThrowOnError>) => (options?.client ?? client).post<DrainAllSmsesResponses, DrainAllSmsesErrors, ThrowOnError>({
    url: '/smses/drain',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Lists all SMS deliveries since the specified date, for the specified timeframe, organization and tags
 *
 * (request type: SearchAllSmsDeliveriesRequest)
 */
export const searchAllSmsDeliveries = <ThrowOnError extends boolean = false>(options?: Options<SearchAllSmsDeliveriesData, ThrowOnError>) => (options?.client ?? client).get<SearchAllSmsDeliveriesResponses, SearchAllSmsDeliveriesErrors, ThrowOnError>({
    responseTransformer: searchAllSmsDeliveriesResponseTransformer,
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/smses',
    ...options
});

/**
 * Sends an SMS message for delivery
 *
 * (request type: SendSmsRequest)
 */
export const sendSms = <ThrowOnError extends boolean = false>(options?: Options<SendSmsData, ThrowOnError>) => (options?.client ?? client).post<SendSmsResponses, SendSmsErrors, ThrowOnError>({
    url: '/smses/send',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Cancels the billing subscription for the organization
 *
 * (request type: CancelSubscriptionRequest)
 */
export const cancelSubscription = <ThrowOnError extends boolean = false>(options: Options<CancelSubscriptionData, ThrowOnError>) => (options.client ?? client).delete<CancelSubscriptionResponses, CancelSubscriptionErrors, ThrowOnError>({
    responseTransformer: cancelSubscriptionResponseTransformer,
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/subscriptions/{Id}',
    ...options
});

/**
 * Fetches the billing subscription for the organization
 *
 * (request type: GetSubscriptionRequest)
 */
export const getSubscription = <ThrowOnError extends boolean = false>(options: Options<GetSubscriptionData, ThrowOnError>) => (options.client ?? client).get<GetSubscriptionResponses, GetSubscriptionErrors, ThrowOnError>({
    responseTransformer: getSubscriptionResponseTransformer,
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/subscriptions/{Id}',
    ...options
});

/**
 * Changes the billing subscription plan for the organization
 *
 * (request type: ChangeSubscriptionPlanRequest)
 */
export const changeSubscriptionPlanPatch = <ThrowOnError extends boolean = false>(options: Options<ChangeSubscriptionPlanPatchData, ThrowOnError>) => (options.client ?? client).patch<ChangeSubscriptionPlanPatchResponses, ChangeSubscriptionPlanPatchErrors, ThrowOnError>({
    responseTransformer: changeSubscriptionPlanPatchResponseTransformer,
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/subscriptions/{Id}/plan',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Changes the billing subscription plan for the organization
 *
 * (request type: ChangeSubscriptionPlanRequest)
 */
export const changeSubscriptionPlanPut = <ThrowOnError extends boolean = false>(options: Options<ChangeSubscriptionPlanPutData, ThrowOnError>) => (options.client ?? client).put<ChangeSubscriptionPlanPutResponses, ChangeSubscriptionPlanPutErrors, ThrowOnError>({
    responseTransformer: changeSubscriptionPlanPutResponseTransformer,
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/subscriptions/{Id}/plan',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Forces the billing subscription to be canceled for the organization.
 *
 * (request type: ForceCancelSubscriptionRequest)
 */
export const forceCancelSubscription = <ThrowOnError extends boolean = false>(options: Options<ForceCancelSubscriptionData, ThrowOnError>) => (options.client ?? client).delete<ForceCancelSubscriptionResponses, ForceCancelSubscriptionErrors, ThrowOnError>({
    responseTransformer: forceCancelSubscriptionResponseTransformer,
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/subscriptions/{Id}/force',
    ...options
});

/**
 * Fetches a history of invoices for the subscription
 *
 * (request type: SearchSubscriptionHistoryRequest)
 */
export const searchSubscriptionHistory = <ThrowOnError extends boolean = false>(options: Options<SearchSubscriptionHistoryData, ThrowOnError>) => (options.client ?? client).get<SearchSubscriptionHistoryResponses, SearchSubscriptionHistoryErrors, ThrowOnError>({
    responseTransformer: searchSubscriptionHistoryResponseTransformer,
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/subscriptions/{Id}/invoices',
    ...options
});

/**
 * Transfers the subscription to another Billing Admin, who will become the subscription buyer
 *
 * (request type: TransferSubscriptionRequest)
 */
export const transferSubscriptionPatch = <ThrowOnError extends boolean = false>(options: Options<TransferSubscriptionPatchData, ThrowOnError>) => (options.client ?? client).patch<TransferSubscriptionPatchResponses, TransferSubscriptionPatchErrors, ThrowOnError>({
    responseTransformer: transferSubscriptionPatchResponseTransformer,
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/subscriptions/{Id}/transfer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Transfers the subscription to another Billing Admin, who will become the subscription buyer
 *
 * (request type: TransferSubscriptionRequest)
 */
export const transferSubscriptionPut = <ThrowOnError extends boolean = false>(options: Options<TransferSubscriptionPutData, ThrowOnError>) => (options.client ?? client).put<TransferSubscriptionPutResponses, TransferSubscriptionPutErrors, ThrowOnError>({
    responseTransformer: transferSubscriptionPutResponseTransformer,
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/subscriptions/{Id}/transfer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Tests access with HMAC signature authentication
 *
 * (request type: GetCallerWithHMACTestingOnlyRequest)
 */
export const getCallerWithHmacTestingOnly = <ThrowOnError extends boolean = false>(options?: Options<GetCallerWithHmacTestingOnlyData, ThrowOnError>) => (options?.client ?? client).get<GetCallerWithHmacTestingOnlyResponses, GetCallerWithHmacTestingOnlyErrors, ThrowOnError>({ url: '/testingonly/authn/hmac/get', ...options });

/**
 * Tests access with token authentication
 *
 * (request type: GetCallerWithTokenOrAPIKeyTestingOnlyRequest)
 */
export const getCallerWithTokenOrApiKeyTestingOnly = <ThrowOnError extends boolean = false>(options?: Options<GetCallerWithTokenOrApiKeyTestingOnlyData, ThrowOnError>) => (options?.client ?? client).get<GetCallerWithTokenOrApiKeyTestingOnlyResponses, GetCallerWithTokenOrApiKeyTestingOnlyErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/testingonly/authn/token/get',
    ...options
});

/**
 * Tests access with no authorization (i.e., anonymous)
 *
 * (request type: AuthorizeByAnonymousTestingOnlyRequest)
 */
export const authorizeByAnonymousTestingOnly = <ThrowOnError extends boolean = false>(options?: Options<AuthorizeByAnonymousTestingOnlyData, ThrowOnError>) => (options?.client ?? client).get<AuthorizeByAnonymousTestingOnlyResponses, AuthorizeByAnonymousTestingOnlyErrors, ThrowOnError>({ url: '/testingonly/authz/anonymous/get', ...options });

/**
 * Tests access with feature authorization
 *
 * (request type: AuthorizeByFeatureTestingOnlyRequest)
 */
export const authorizeByFeatureTestingOnly = <ThrowOnError extends boolean = false>(options?: Options<AuthorizeByFeatureTestingOnlyData, ThrowOnError>) => (options?.client ?? client).get<AuthorizeByFeatureTestingOnlyResponses, AuthorizeByFeatureTestingOnlyErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/testingonly/authz/feature/get',
    ...options
});

/**
 * Tests access with role authorization
 *
 * (request type: AuthorizeByTokenWithRoleTestingOnlyRequest)
 */
export const authorizeByTokenWithRoleTestingOnly = <ThrowOnError extends boolean = false>(options?: Options<AuthorizeByTokenWithRoleTestingOnlyData, ThrowOnError>) => (options?.client ?? client).get<AuthorizeByTokenWithRoleTestingOnlyResponses, AuthorizeByTokenWithRoleTestingOnlyErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/testingonly/authz/role/get',
    ...options
});

/**
 * Tests content negotiation with a specified format
 *
 * (request type: ContentNegotiationsTestingOnlyRequest)
 */
export const contentNegotiationsTestingOnly = <ThrowOnError extends boolean = false>(options?: Options<ContentNegotiationsTestingOnlyData, ThrowOnError>) => (options?.client ?? client).get<ContentNegotiationsTestingOnlyResponses, ContentNegotiationsTestingOnlyErrors, ThrowOnError>({ url: '/testingonly/negotiations/get', ...options });

/**
 * Destroys all repositories
 *
 * (request type: DestroyAllRepositoriesRequest)
 */
export const destroyAllRepositories = <ThrowOnError extends boolean = false>(options?: Options<DestroyAllRepositoriesData, ThrowOnError>) => (options?.client ?? client).post<DestroyAllRepositoriesResponses, DestroyAllRepositoriesErrors, ThrowOnError>({
    url: '/testingonly/repositories/destroy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Tests download of streams
 *
 * (request type: DownloadStreamTestingOnlyRequest)
 */
export const downloadStreamTestingOnly = <ThrowOnError extends boolean = false>(options?: Options<DownloadStreamTestingOnlyData, ThrowOnError>) => (options?.client ?? client).get<DownloadStreamTestingOnlyResponses, DownloadStreamTestingOnlyErrors, ThrowOnError>({ url: '/testingonly/download', ...options });

/**
 * Tests errors, by returning an error result
 *
 * (request type: ErrorsErrorTestingOnlyRequest)
 */
export const errorsErrorTestingOnly = <ThrowOnError extends boolean = false>(options?: Options<ErrorsErrorTestingOnlyData, ThrowOnError>) => (options?.client ?? client).get<ErrorsErrorTestingOnlyResponses, ErrorsErrorTestingOnlyErrors, ThrowOnError>({ url: '/testingonly/errors/error', ...options });

/**
 * Tests errors, by throwing an exception
 *
 * (request type: ErrorsThrowTestingOnlyRequest)
 */
export const errorsThrowTestingOnly = <ThrowOnError extends boolean = false>(options?: Options<ErrorsThrowTestingOnlyData, ThrowOnError>) => (options?.client ?? client).get<ErrorsThrowTestingOnlyResponses, ErrorsThrowTestingOnlyErrors, ThrowOnError>({ url: '/testingonly/errors/throws', ...options });

/**
 * Tests response formats
 *
 * (request type: FormatsTestingOnlyRequest)
 */
export const formatsTestingOnly = <ThrowOnError extends boolean = false>(options?: Options<FormatsTestingOnlyData, ThrowOnError>) => (options?.client ?? client).post<FormatsTestingOnlyResponses, FormatsTestingOnlyErrors, ThrowOnError>({
    responseTransformer: formatsTestingOnlyResponseTransformer,
    url: '/testingonly/formats/roundtrip',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Tests the use of an array in a GET request
 *
 * (request type: GetWithSimpleArrayTestingOnlyRequest)
 */
export const getWithSimpleArrayTestingOnly = <ThrowOnError extends boolean = false>(options?: Options<GetWithSimpleArrayTestingOnlyData, ThrowOnError>) => (options?.client ?? client).get<GetWithSimpleArrayTestingOnlyResponses, GetWithSimpleArrayTestingOnlyErrors, ThrowOnError>({ url: '/testingonly/general/get/array', ...options });

/**
 * Tests the use of an empty body in a POST request
 *
 * (request type: PostWithEmptyBodyTestingOnlyRequest)
 */
export const postWithEmptyBodyTestingOnly = <ThrowOnError extends boolean = false>(options?: Options<PostWithEmptyBodyTestingOnlyData, ThrowOnError>) => (options?.client ?? client).post<PostWithEmptyBodyTestingOnlyResponses, PostWithEmptyBodyTestingOnlyErrors, ThrowOnError>({
    url: '/testingonly/general/body/empty',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Tests the use of an empty body in a POST request that has required properties
 *
 * (request type: PostWithEmptyBodyAndRequiredPropertiesTestingOnlyRequest)
 */
export const postWithEmptyBodyAndRequiredPropertiesTestingOnly = <ThrowOnError extends boolean = false>(options?: Options<PostWithEmptyBodyAndRequiredPropertiesTestingOnlyData, ThrowOnError>) => (options?.client ?? client).post<PostWithEmptyBodyAndRequiredPropertiesTestingOnlyResponses, PostWithEmptyBodyAndRequiredPropertiesTestingOnlyErrors, ThrowOnError>({
    url: '/testingonly/general/body/empty/required',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Tests the use of an empty post body with route parameters Notice the use of Infrastructure.Web.Api.Interfaces.WebRequest`2 instead of Infrastructure.Web.Api.Interfaces.IWebRequest`1
 *
 * (request type: PostWithRouteParamsAndEmptyBodyTestingOnlyRequest)
 */
export const postWithRouteParamsAndEmptyBodyTestingOnly = <ThrowOnError extends boolean = false>(options: Options<PostWithRouteParamsAndEmptyBodyTestingOnlyData, ThrowOnError>) => (options.client ?? client).post<PostWithRouteParamsAndEmptyBodyTestingOnlyResponses, PostWithRouteParamsAndEmptyBodyTestingOnlyErrors, ThrowOnError>({
    url: '/testingonly/general/body/{astringproperty}/{anumberproperty}/route',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Tests the use of reference types, values types, and enums anywhere in a GET request
 *
 * (request type: GetTestingOnlyRequest)
 */
export const getTestingOnly = <ThrowOnError extends boolean = false>(options: Options<GetTestingOnlyData, ThrowOnError>) => (options.client ?? client).get<GetTestingOnlyResponses, GetTestingOnlyErrors, ThrowOnError>({ url: '/testingonly/general/get/a/{AnEnumRouteProperty}/b/{AnIntRouteProperty}/c/{AStringRouteProperty}', ...options });

/**
 * Tests the use of reference types, values types, and enums anywhere in a POST request
 *
 * (request type: PostTestingOnlyRequest)
 */
export const postTestingOnly = <ThrowOnError extends boolean = false>(options: Options<PostTestingOnlyData, ThrowOnError>) => (options.client ?? client).post<PostTestingOnlyResponses, PostTestingOnlyErrors, ThrowOnError>({
    url: '/testingonly/general/post/a/{AnEnumRouteProperty}/b/{AnIntRouteProperty}/c/{AStringRouteProperty}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Tests the use of reference types, values types, and enums anywhere in a SEARCH request
 *
 * (request type: SearchTestingOnlyRequest)
 */
export const searchTestingOnly = <ThrowOnError extends boolean = false>(options: Options<SearchTestingOnlyData, ThrowOnError>) => (options.client ?? client).get<SearchTestingOnlyResponses, SearchTestingOnlyErrors, ThrowOnError>({ url: '/testingonly/general/search/a/{AnEnumRouteProperty}/b/{AnIntRouteProperty}/c/{AStringRouteProperty}', ...options });

/**
 * Tests access with anonymous access
 *
 * (request type: GetInsecureTestingOnlyRequest)
 */
export const getInsecureTestingOnly = <ThrowOnError extends boolean = false>(options?: Options<GetInsecureTestingOnlyData, ThrowOnError>) => (options?.client ?? client).get<GetInsecureTestingOnlyResponses, GetInsecureTestingOnlyErrors, ThrowOnError>({ url: '/testingonly/security/none', ...options });

/**
 * Tests access with anonymous access
 *
 * (request type: PostInsecureTestingOnlyRequest)
 */
export const postInsecureTestingOnly = <ThrowOnError extends boolean = false>(options?: Options<PostInsecureTestingOnlyData, ThrowOnError>) => (options?.client ?? client).post<PostInsecureTestingOnlyResponses, PostInsecureTestingOnlyErrors, ThrowOnError>({
    url: '/testingonly/security/none',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Tests the automatic population of default organization in tenanted requests
 *
 * (request type: GetTenantedTestingOnlyRequest)
 */
export const getTenantedTestingOnly = <ThrowOnError extends boolean = false>(options?: Options<GetTenantedTestingOnlyData, ThrowOnError>) => (options?.client ?? client).get<GetTenantedTestingOnlyResponses, GetTenantedTestingOnlyErrors, ThrowOnError>({ url: '/testingonly/tenanted', ...options });

/**
 * Tests OpenAPI swagger for application/x-www-form-urlencoded POST requests
 *
 * (request type: OpenApiPostFormUrlEncodedTestingOnlyRequest)
 */
export const openApiPostFormUrlEncodedTestingOnly = <ThrowOnError extends boolean = false>(options: Options<OpenApiPostFormUrlEncodedTestingOnlyData, ThrowOnError>) => (options.client ?? client).post<OpenApiPostFormUrlEncodedTestingOnlyResponses, OpenApiPostFormUrlEncodedTestingOnlyErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    url: '/testingonly/openapi/{Id}/urlencoded',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options.headers
    }
});

/**
 * Tests OpenAPI swagger for GET requests This includes multiple lines explaining things
 *
 * (request type: OpenApiGetTestingOnlyRequest)
 */
export const openApiGetTestingOnly = <ThrowOnError extends boolean = false>(options: Options<OpenApiGetTestingOnlyData, ThrowOnError>) => (options.client ?? client).get<OpenApiGetTestingOnlyResponses, OpenApiGetTestingOnlyErrors, ThrowOnError>({ url: '/testingonly/openapi/{Id}', ...options });

/**
 * Tests OpenAPI swagger for POST requests
 *
 * (request type: OpenApiPutTestingOnlyRequest)
 */
export const openApiPutTestingOnlyPatch = <ThrowOnError extends boolean = false>(options: Options<OpenApiPutTestingOnlyPatchData, ThrowOnError>) => (options.client ?? client).patch<OpenApiPutTestingOnlyPatchResponses, OpenApiPutTestingOnlyPatchErrors, ThrowOnError>({
    url: '/testingonly/openapi/{Id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Tests OpenAPI swagger for POST requests
 *
 * (request type: OpenApiPostTestingOnlyRequest)
 */
export const openApiPostTestingOnly = <ThrowOnError extends boolean = false>(options: Options<OpenApiPostTestingOnlyData, ThrowOnError>) => (options.client ?? client).post<OpenApiPostTestingOnlyResponses, OpenApiPostTestingOnlyErrors, ThrowOnError>({
    url: '/testingonly/openapi/{Id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Tests OpenAPI swagger for POST requests
 *
 * (request type: OpenApiPutTestingOnlyRequest)
 */
export const openApiPutTestingOnlyPut = <ThrowOnError extends boolean = false>(options: Options<OpenApiPutTestingOnlyPutData, ThrowOnError>) => (options.client ?? client).put<OpenApiPutTestingOnlyPutResponses, OpenApiPutTestingOnlyPutErrors, ThrowOnError>({
    url: '/testingonly/openapi/{Id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Tests OpenAPI swagger for multipart/form-data POST requests
 *
 * (request type: OpenApiPostMultiPartFormDataTestingOnlyRequest)
 */
export const openApiPostMultiPartFormDataTestingOnly = <ThrowOnError extends boolean = false>(options: Options<OpenApiPostMultiPartFormDataTestingOnlyData, ThrowOnError>) => (options.client ?? client).post<OpenApiPostMultiPartFormDataTestingOnlyResponses, OpenApiPostMultiPartFormDataTestingOnlyErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/testingonly/openapi/{Id}/form-data',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Tests the use of a redirect for a GET method
 *
 * (request type: GetWithRedirectTestingOnlyRequest)
 */
export const getWithRedirectTestingOnly = <ThrowOnError extends boolean = false>(options?: Options<GetWithRedirectTestingOnlyData, ThrowOnError>) => (options?.client ?? client).get<GetWithRedirectTestingOnlyResponses, GetWithRedirectTestingOnlyErrors, ThrowOnError>({ url: '/testingonly/redirect/get', ...options });

/**
 * Tests the use of a redirect for a POST method
 *
 * (request type: PostWithRedirectTestingOnlyRequest)
 */
export const postWithRedirectTestingOnly = <ThrowOnError extends boolean = false>(options?: Options<PostWithRedirectTestingOnlyData, ThrowOnError>) => (options?.client ?? client).post<PostWithRedirectTestingOnlyResponses, PostWithRedirectTestingOnlyErrors, ThrowOnError>({
    url: '/testingonly/redirect/post',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Tests request correlation
 *
 * (request type: RequestCorrelationsTestingOnlyRequest)
 */
export const requestCorrelationsTestingOnly = <ThrowOnError extends boolean = false>(options?: Options<RequestCorrelationsTestingOnlyData, ThrowOnError>) => (options?.client ?? client).get<RequestCorrelationsTestingOnlyResponses, RequestCorrelationsTestingOnlyErrors, ThrowOnError>({ url: '/testingonly/correlations/get', ...options });

/**
 * Tests default status code for DELETE requests, with no response
 *
 * (request type: StatusesDeleteTestingOnlyRequest)
 */
export const statusesDeleteTestingOnly = <ThrowOnError extends boolean = false>(options?: Options<StatusesDeleteTestingOnlyData, ThrowOnError>) => (options?.client ?? client).delete<StatusesDeleteTestingOnlyResponses, StatusesDeleteTestingOnlyErrors, ThrowOnError>({ url: '/testingonly/statuses/delete1', ...options });

/**
 * Tests default status code for DELETE requests, with a response
 *
 * (request type: StatusesDeleteWithResponseTestingOnlyRequest)
 */
export const statusesDeleteWithResponseTestingOnly = <ThrowOnError extends boolean = false>(options?: Options<StatusesDeleteWithResponseTestingOnlyData, ThrowOnError>) => (options?.client ?? client).delete<StatusesDeleteWithResponseTestingOnlyResponses, StatusesDeleteWithResponseTestingOnlyErrors, ThrowOnError>({ url: '/testingonly/statuses/delete2', ...options });

/**
 * Tests default status code for GET requests
 *
 * (request type: StatusesGetTestingOnlyRequest)
 */
export const statusesGetTestingOnly = <ThrowOnError extends boolean = false>(options?: Options<StatusesGetTestingOnlyData, ThrowOnError>) => (options?.client ?? client).get<StatusesGetTestingOnlyResponses, StatusesGetTestingOnlyErrors, ThrowOnError>({ url: '/testingonly/statuses/get', ...options });

/**
 * Tests default status code for POST requests, without a location
 *
 * (request type: StatusesPostTestingOnlyRequest)
 */
export const statusesPostTestingOnly = <ThrowOnError extends boolean = false>(options?: Options<StatusesPostTestingOnlyData, ThrowOnError>) => (options?.client ?? client).post<StatusesPostTestingOnlyResponses, StatusesPostTestingOnlyErrors, ThrowOnError>({
    url: '/testingonly/statuses/post1',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Tests default status code for POST requests, with a location
 *
 * (request type: StatusesPostWithLocationTestingOnlyRequest)
 */
export const statusesPostWithLocationTestingOnly = <ThrowOnError extends boolean = false>(options?: Options<StatusesPostWithLocationTestingOnlyData, ThrowOnError>) => (options?.client ?? client).post<StatusesPostWithLocationTestingOnlyResponses, StatusesPostWithLocationTestingOnlyErrors, ThrowOnError>({
    url: '/testingonly/statuses/post2',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Tests default status code for PUT/PATCH requests
 *
 * (request type: StatusesPutPatchTestingOnlyRequest)
 */
export const statusesPutPatchTestingOnlyPatch = <ThrowOnError extends boolean = false>(options?: Options<StatusesPutPatchTestingOnlyPatchData, ThrowOnError>) => (options?.client ?? client).patch<StatusesPutPatchTestingOnlyPatchResponses, StatusesPutPatchTestingOnlyPatchErrors, ThrowOnError>({
    url: '/testingonly/statuses/putpatch',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Tests default status code for PUT/PATCH requests
 *
 * (request type: StatusesPutPatchTestingOnlyRequest)
 */
export const statusesPutPatchTestingOnlyPut = <ThrowOnError extends boolean = false>(options?: Options<StatusesPutPatchTestingOnlyPutData, ThrowOnError>) => (options?.client ?? client).put<StatusesPutPatchTestingOnlyPutResponses, StatusesPutPatchTestingOnlyPutErrors, ThrowOnError>({
    url: '/testingonly/statuses/putpatch',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Tests default status code for SEARCH requests
 *
 * (request type: StatusesSearchTestingOnlyRequest)
 */
export const statusesSearchTestingOnly = <ThrowOnError extends boolean = false>(options?: Options<StatusesSearchTestingOnlyData, ThrowOnError>) => (options?.client ?? client).get<StatusesSearchTestingOnlyResponses, StatusesSearchTestingOnlyErrors, ThrowOnError>({ url: '/testingonly/statuses/search', ...options });

/**
 * Tests response for non-validated requests
 *
 * (request type: ValidationsUnvalidatedTestingOnlyRequest)
 */
export const validationsUnvalidatedTestingOnly = <ThrowOnError extends boolean = false>(options?: Options<ValidationsUnvalidatedTestingOnlyData, ThrowOnError>) => (options?.client ?? client).get<ValidationsUnvalidatedTestingOnlyResponses, ValidationsUnvalidatedTestingOnlyErrors, ThrowOnError>({ url: '/testingonly/validations/unvalidated', ...options });

/**
 * Tests response for validated GET requests
 *
 * (request type: ValidationsValidatedGetTestingOnlyRequest)
 */
export const validationsValidatedGetTestingOnly = <ThrowOnError extends boolean = false>(options: Options<ValidationsValidatedGetTestingOnlyData, ThrowOnError>) => (options.client ?? client).get<ValidationsValidatedGetTestingOnlyResponses, ValidationsValidatedGetTestingOnlyErrors, ThrowOnError>({ url: '/testingonly/validations/validated/{Id}', ...options });

/**
 * Tests response for validated POST requests
 *
 * (request type: ValidationsValidatedPostTestingOnlyRequest)
 */
export const validationsValidatedPostTestingOnly = <ThrowOnError extends boolean = false>(options: Options<ValidationsValidatedPostTestingOnlyData, ThrowOnError>) => (options.client ?? client).post<ValidationsValidatedPostTestingOnlyResponses, ValidationsValidatedPostTestingOnlyErrors, ThrowOnError>({
    url: '/testingonly/validations/validated/{Id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Notifies a Twilio Email event, via a webhook Supports either HMAC authentication or anonymous
 *
 * (request type: TwilioNotifyEmailWebhookEventRequest)
 */
export const twilioNotifyEmailWebhookEvent = <ThrowOnError extends boolean = false>(options?: Options<TwilioNotifyEmailWebhookEventData, ThrowOnError>) => (options?.client ?? client).post<TwilioNotifyEmailWebhookEventResponses, TwilioNotifyEmailWebhookEventErrors, ThrowOnError>({
    url: '/webhooks/twilio/email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Notifies a Twilio SMS event, via a webhook
 *
 * (request type: TwilioNotifySmsWebhookEventRequest)
 */
export const twilioNotifySmsWebhookEvent = <ThrowOnError extends boolean = false>(options?: Options<TwilioNotifySmsWebhookEventData, ThrowOnError>) => (options?.client ?? client).post<TwilioNotifySmsWebhookEventResponses, TwilioNotifySmsWebhookEventErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    url: '/webhooks/twilio/sms',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options?.headers
    }
});

/**
 * Delivers a usage event
 *
 * (request type: DeliverUsageRequest)
 */
export const deliverUsage = <ThrowOnError extends boolean = false>(options?: Options<DeliverUsageData, ThrowOnError>) => (options?.client ?? client).post<DeliverUsageResponses, DeliverUsageErrors, ThrowOnError>({
    url: '/usages/deliver',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Drains all the pending usage messages
 *
 * (request type: DrainAllUsagesRequest)
 */
export const drainAllUsages = <ThrowOnError extends boolean = false>(options?: Options<DrainAllUsagesData, ThrowOnError>) => (options?.client ?? client).post<DrainAllUsagesResponses, DrainAllUsagesErrors, ThrowOnError>({
    url: '/usages/drain',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Changes the user's contact address
 *
 * (request type: ChangeProfileContactAddressRequest)
 */
export const changeProfileContactAddressPatch = <ThrowOnError extends boolean = false>(options: Options<ChangeProfileContactAddressPatchData, ThrowOnError>) => (options.client ?? client).patch<ChangeProfileContactAddressPatchResponses, ChangeProfileContactAddressPatchErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/profiles/{UserId}/contact',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Changes the user's contact address
 *
 * (request type: ChangeProfileContactAddressRequest)
 */
export const changeProfileContactAddressPut = <ThrowOnError extends boolean = false>(options: Options<ChangeProfileContactAddressPutData, ThrowOnError>) => (options.client ?? client).put<ChangeProfileContactAddressPutResponses, ChangeProfileContactAddressPutErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/profiles/{UserId}/contact',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Changes the user's profile information
 *
 * (request type: ChangeProfileRequest)
 */
export const changeProfilePatch = <ThrowOnError extends boolean = false>(options: Options<ChangeProfilePatchData, ThrowOnError>) => (options.client ?? client).patch<ChangeProfilePatchResponses, ChangeProfilePatchErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/profiles/{UserId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Changes the user's profile information
 *
 * (request type: ChangeProfileRequest)
 */
export const changeProfilePut = <ThrowOnError extends boolean = false>(options: Options<ChangeProfilePutData, ThrowOnError>) => (options.client ?? client).put<ChangeProfilePutResponses, ChangeProfilePutErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/profiles/{UserId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Removes the user's avatar image
 *
 * (request type: DeleteProfileAvatarRequest)
 */
export const deleteProfileAvatar = <ThrowOnError extends boolean = false>(options: Options<DeleteProfileAvatarData, ThrowOnError>) => (options.client ?? client).delete<DeleteProfileAvatarResponses, DeleteProfileAvatarErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/profiles/{UserId}/avatar',
    ...options
});

/**
 * Changes the user's avatar image
 *
 * (request type: ChangeProfileAvatarRequest)
 */
export const changeProfileAvatarPatch = <ThrowOnError extends boolean = false>(options: Options<ChangeProfileAvatarPatchData, ThrowOnError>) => (options.client ?? client).patch<ChangeProfileAvatarPatchResponses, ChangeProfileAvatarPatchErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/profiles/{UserId}/avatar',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Changes the user's avatar image
 *
 * (request type: ChangeProfileAvatarRequest)
 */
export const changeProfileAvatarPut = <ThrowOnError extends boolean = false>(options: Options<ChangeProfileAvatarPutData, ThrowOnError>) => (options.client ?? client).put<ChangeProfileAvatarPutResponses, ChangeProfileAvatarPutErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ name: 'Authorization', type: 'apiKey' }, {
            in: 'query',
            name: 'apikey',
            type: 'apiKey'
        }],
    url: '/profiles/{UserId}/avatar',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Fetches the profile of the authenticated user
 *
 * (request type: GetProfileForCallerRequest)
 */
export const getProfileForCaller = <ThrowOnError extends boolean = false>(options?: Options<GetProfileForCallerData, ThrowOnError>) => (options?.client ?? client).get<GetProfileForCallerResponses, GetProfileForCallerErrors, ThrowOnError>({ url: '/profiles/me', ...options });
